import React, { useEffect, useState } from "react";
import regbanner from "../../../assets/icons/panDob.svg";
import InputField from "../../UI/InputField/InputField";
import Button from "../../UI/Button/Button";
import {
    authenticateNavBarObj,
    containerUrl,
    dashboardUrl,
    dematNavBarObj,
    DIY,
    hasNavBarEntry,
    leftNavBarArray,
    statusUrl,
} from "../../utils/constants";

import { pan, alphaNumExp, nonIndpan } from "../../utils/regex";
import "./PANInfo.scss";
import {
    ACheckPanIbeats,
    AGetClientDetailsByPan,
    AIsPANExists,
    ASavePanDobDetails,
    AGetCkycNumber,
    AGetKraDetails,
    AGetEmployeeByPan,
    ACheckUCCExists,
    APanVerification,
    ACheckKraPan,
} from "../../Services/registration/panDobApiService";
import {
    ACreateLeadSource,
    ALeadFetchApi,
} from "../../Services/registration/registrationApiService";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import GlobalStore from "../../store/globalStore";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
    clientContinue,
    utmDurationInfoObj,
    updateUtmInfo,
    setStageData,
    ageCalculator,
    localStorageGetItem,
    localStorageSetItem,
} from "../../Services/globalService";
import { APendingUploadList } from "../../Services/dashboard/eSignApiServices";
import {
    AGetCacheData,
    AGetStageCompletionStatus,
} from "../../Services/registration/continueApiService";
import { checkModuleCompleteness } from "../../Profile/ProfileNavBar/ProfileNavBar";
import Backdrop from "../../UI/Backdrop/Backdrop";
import Calender from "../../UI/Calender/Calender";
import moment from "moment";
import gtmService from "../../Services/gtmService";
import cleverTapEvents from "../../../config/cleverTapEvents";
import mixpanelService from "../../Services/mixpanelService";
import mixpanelEvents, { getScreenName, webFlowEvents } from "../../../config/mixpanelEvents";
import { nonRouteScreenNames } from "../../../config/aopScreenNames";
import useQuery from "../../../customHooks/useQuery";
import { ClevertapService } from "../../Services/clevertapService";
import DocumentBrowse, {
    DocDetailFormat,
} from "../../UI/DocumentBrowse/DocumentBrowse";
import { initialPanDocObj } from "../../DocumentVerification/DocVerificationForm/DocVerificationForm";
import {
    AextractPanNew,
    ASaveDocumentDetails,
    QCServiceTaskCreation,
} from "../../Services/dashboard/docVerificationAPIServices";
import { AUploadDocument } from "../../Services/dashboard/brokerageServices";
import { AppsFlyerService } from "../../Services/appsFlyerService";
import appsFlyerEvents from "../../../config/appsFlyerEvents";
import Checkbox from "../../UI/Checkbox/Checkbox";
import config from "../../../config/domain";
import { errorMessage } from "../../utils/errorMessage";
import { ASendSms } from "../../Services/dashboard/ipvApiServices";
import { errorCode, errorMsg } from "../../../ErrorCode/ErrorCode";
import Loader from "../../UI/Loader/Loader";
import { getProfileDetailsFromAadhar } from "../ShareAdd/ShareAdd";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import PANInfoJoint from "./PANInfoJoint";
import { SUBTYPE_MAP } from "./PANInfoJoint.utils";

export interface IPanDobFields {
    pan: string;
    dob: Date | null;
    aadharLinked: "No" | "Yes" | "Not Sure";
    aadhaarNo?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    fatherName?: string;
    gurdianPanNo?: any;
    gurdianDOB?: Date | null;
    gurdianFName?: string;
    gurdianMName?: string;
    gurdianLName?: string;
    fullname?: any;
    minorPan?: string;
    relationshipId?: string;
}

const panValidationKeyList: any = {
    PanStatus: "PanStatusMsg",
    Name: "NameMsg",
    Dob: "DobMsg",
    SeedingStatus: "SeedingStatusMsg",
};

export interface iGeoLocation {
    loaded: boolean;
    coordinates: { lat: string; lng: string };
    error: boolean;
}

export type saveDocumentObj = {
    documentCategoryId?: string;
    documentId?: string;
    fileName: string;
    isfilecropped: boolean;
    mimeType: string | undefined;
    panno: string;
    personaldetailsid: string;
    autoqc: boolean;
    iskycdocument: boolean;
    documentNumber?: string;
};

export interface ILocalQueryObject {
    email?: string;
    mobile?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    pan?: string;
    dob?: string;
    productid?: string;
    categoryid?: string;
    rmid?: string;
    leadid?: string;
    accountCategory?: string;
    createdBy?: any;
    entityType?: any;
    clienttype?: any;
    entitySubType?: any;
    is_guradian_pan?: any;
    isguradianpan?: boolean;
    fullname?: any;
    uccCode?: any;
    guardianPan?: any;
}

export interface PANInfoProps { }
let isPanLinkedToAadhar: boolean;

const relationShipList = [
    {
        display: "Father",
        value: 1,
    },
    {
        display: "Mother",
        value: 2,
    },
    // {
    //     display: "Self",
    //     value: 1,
    // },
    // {
    //     display: "Spouse",
    //     value: 2,
    // },
    // {
    //     display: "Dependent Child",
    //     value: 3,
    // },
    // {
    //     display: "Dependent Parent",
    //     value: 4,
    // }
];

const PANInfoMinor: React.FC<PANInfoProps> = (props) => {
    let panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
    // Fetch query params for clervertap
    const quryParams = useQuery();
    const UTM_SOURCE = quryParams.get("utm_source")
        ? quryParams.get("utm_source")
        : "";
    const UTM_MEDIUM = quryParams.get("utm_medium")
        ? quryParams.get("utm_medium")
        : "";
    const UTM_CAMPAIGN = quryParams.get("utm_campaign")
        ? quryParams.get("utm_campaign")
        : "";
    let localURL = localStorageGetItem("currentURL"),
        navigateURL: string = "";
    const localProductCode = quryParams.get("productCode");
    const localProuctObj = quryParams.get("localProuctObj");
    const id = quryParams.get("id");
    const name = quryParams.get("name");
    const skipUrl = quryParams.get("skipUrl");
    const empCode = quryParams.get('empCode');

    const [dematAccountFound, setDematAccountFound] = React.useState<any>(null);
    if (
        localURL !== null &&
        localURL !== undefined &&
        localURL !== "" &&
        localURL?.length > 0
    ) {
        navigateURL = window.atob(localURL);
        localURL = window.atob(localURL);
    }
    const [prodObj, setProdObj] = React.useState<ILocalQueryObject>({});
    const [values, setValues] = React.useState<IPanDobFields>({
        pan: "",
        aadharLinked: "No",
        dob: null,
        //aadhaarNo: "",
        firstName: "",
        middleName: "",
        lastName: "",
        fatherName: "",
        minorPan: "no",
        relationshipId: "",
    });
    const [validPan, setValidPan] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [errCode, setErrCode] = React.useState<any>("");
    const [startTime, setStartTime] = React.useState<Date>(new Date());
    let isEmployee: boolean = false;
    const [errors, setErrors] = React.useState<{
        [key in keyof IPanDobFields]?: string;
    }>({
        pan: undefined,
        dob: undefined,
        aadharLinked: undefined,
        aadhaarNo: undefined,
        firstName: undefined,
        middleName: undefined,
        lastName: undefined,
    });
    // const history = useHistory();
    const navigate = useNavigate()
    const [removePanImg, setRemovePanImg] = React.useState<boolean>(false);
    const [utmObj, setUtmObj] = React.useState<any>(null);
    const [panObj, setPanObj] = React.useState<DocDetailFormat>({
        ...initialPanDocObj,
    });

    const [consent, setConsent] = React.useState<boolean>(true);
    const [togPhoto, setTogPhoto] = React.useState<boolean>(false);
    const [panNumberMatched, setPanNumberMatched] = React.useState(false);
    const [dobChecked, setDobChecked] = React.useState(false);
    const [isNormalClient, setIsNormalClient] = React.useState<boolean>(false);
    const [panDobState, setPanDobState] = React.useState("");
    const [skipUrlBoolean, setSkipUrlBoolean] = React.useState<boolean>(false);
    const [errorFoundInPanValidation, setErrorFoundInPanValidation] =
        useState<boolean>(false);
    const [cacheResponse, setCacheResponse] = React.useState<any>(null);
    //setModalDisplayText

    const [panUploadObject, setPanUploadObject] = React.useState<any>("");
    const [panUploaded, setPanUploaded] = React.useState<boolean>(false);

    const [liveLocationCheck, setLiveLocationCheck] = useState<any>({
        checkPhotoLiveness: false,
        checkLocation: false,
    });
    const [stageBooleanFlags, setStageBooleanFlags] = React.useState<{
        isPersonalStage: boolean;
        isProfileStage: boolean;
    }>({
        isPersonalStage: false,
        isProfileStage: false,
    });
    const [photoErrorMsg, setPhotoErrorMsg] = React.useState("");
    const [seedingPopup, setSeedingPopup] = React.useState<boolean>(false);
    const [checkpanaaddharflag, setCheckpanaaddharflag] = React.useState<boolean>(
        GlobalStore.stageStatus.checkpanaaddharflag === false ? true : false
    );
    const [panOCR, setPanOCR] = useState<any>(null);
    const [willDoLater, setWillDoLater] = useState<boolean>(false);
    const [panFileUploaded, setPanFileUploaded] = useState<boolean>(false);
    const [panFileUploadedLoader, setPanFileUploadedLoader] =
        useState<boolean>(false);
    const [invalidPanFieldUploadedMsg, setInvalidPanFileUploadedMsg] =
        React.useState<string>("");
    const [applicationModeType, setApplicationModeType] = useState<any>("");
    const [modalDisplayText, setModalDisplayText] = useState<any>("");
    const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);

    // Non-KRA clients are shown the DigiLocker consent note on this page. It is
    // its own screen for analytics even though it shares the /pan route, so it
    // is fired here rather than from the route based MixpanelPageTracker.
    const nonKraConsentTracked = React.useRef(false);
    React.useEffect(() => {
      if (
        showSubmitModal &&
        applicationModeType === "isDigiLocker" &&
        !nonKraConsentTracked.current
      ) {
        nonKraConsentTracked.current = true;
        mixpanelService({
          event: mixpanelEvents.SCREEN_LOAD,
          screen_name: nonRouteScreenNames.nonKraConsentSelection,
        });
      }
    }, [showSubmitModal, applicationModeType]);
    const [panInvalidMsg, setPanInvalidMsg] = React.useState<string>("");
    //  const [panValidationResp,setPanValidationResp]=React.useState<any>();
    let panValidationResp: any;
    const [applicationInitializedFlag, setApplicationInitializedFlag] =
        useState<boolean>(false);
    const [submitFlag, setSubmitFlag] = useState<boolean>(false);
    const [extractPanResponse, setExtractPanResponse] = React.useState<{
        age: number;
        date_of_birth: string;
        date_of_issue: string;
        fathers_name: string;
        id_number: string;
        is_scanned: boolean;
        minor: boolean;
        name_on_card: string;
        pan_type: string;
    }>();
    let salesLandingPage = localStorageGetItem("salesLandingPage");
    const [documentsInfo, setDocumentInfo] = useState({
        totalDocs: [],
        totalDocsCount: 0,
        uploadedDocsCount: 0,
    });

    const [entityType, setEntityType] = useState("")
    const [entitySubType, setEntitySubType] = useState("")

    let panDob: string;
    const saveDetails: saveDocumentObj[] = [];
    const saveKraDetails: saveDocumentObj[] = [];

    let kraDocCount = 0;
    let kraDocs = 0;
    // let totalDocs: Array<string> = [];
    // let totalDocsCount = 0;
    // let uploadedDocsCount = 0;

    let isPanLinkedToAadhar: boolean;
    const objAccType =
        window.sessionStorage.getItem("objAccType") || ""

    const convertDate = (dateString: string) => {
        // Split the input date string by "/"
        const [day, month, year] = dateString.split("/");

        // Create a new Date object with the parsed values
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); // month - 1 because months are zero-indexed

        // Format the date to "mm-dd-yyyy"
        const formattedDate = `${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;

        return formattedDate;
    };

    React.useEffect(() => {
        setEntityType(GlobalStore.entityType)
        setEntitySubType(GlobalStore.entitySubType)
        if (empCode !== null && empCode !== undefined && empCode !== "") {
            window.sessionStorage.setItem('empCode', empCode)
        }
        // Assign utm object into local state
        const objUtm = JSON.parse(
            window.sessionStorage.getItem("objUTM_Info") || "{}"
        );
        setUtmObj(objUtm);

        if (
            containerUrl.continue === clientContinue() &&
            !GlobalStore.isPartialFilledClient
        ) {
            // history.push(containerUrl.continue);
            navigate(containerUrl.continue)
        } else {
            if (!GlobalStore.leadId || GlobalStore.leadId === "") {
                // history.push(containerUrl.registration);
            } else {
                init();
                window.scroll(0, 0);
            }
        }
        if (
            skipUrl !== null &&
            skipUrl !== undefined &&
            skipUrl !== "" &&
            skipUrl?.toLowerCase() == "yes"
        ) {
            if (
                id !== null &&
                id !== undefined &&
                id !== "" &&
                id?.length > 0 &&
                name !== null &&
                name !== undefined &&
                name !== "" &&
                name?.length > 0
            ) {
                // setIsLoading(true);
                setPanFileUploadedLoader(true);
                ALeadFetchApi(
                    (res: any) => {
                        if (!res || res?.error) {
                            // setErrCode(164)
                            setErrCode(errCode + res?.error);
                            setSkipUrlBoolean(true);
                            setPanFileUploaded(true);
                            // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
                        } else if (res?.data) {
                            if (Array?.isArray(res?.data) && res?.data?.length > 0) {
                                let productObj = res?.data[0] as ILocalQueryObject;
                                GlobalStore.externalDetails = productObj
                                GlobalStore.entityType = productObj?.entityType
                                GlobalStore.entitySubType = productObj?.entitySubType
                                // make sure to change
                                if (productObj?.entitySubType == "Minor") {
                                    setEntitySubType("Minor")
                                } else if (productObj?.entityType == "NONINDIVIDUAL" || productObj?.entityType == "NON INDIVIDUAL") {
                                    setEntityType("NONINDIVIDUAL")
                                } else {
                                    setEntitySubType(productObj?.entitySubType)
                                    setEntityType(productObj?.entityType)
                                }
                                setPanFileUploadedLoader(false);
                                if (
                                    productObj?.createdBy != null &&
                                    productObj?.createdBy !== undefined
                                ) {
                                    if (productObj?.isguradianpan) {
                                        productObj.guardianPan = productObj.pan
                                    }
                                    setProdObj(productObj);
                                    setSkipUrlBoolean(true);
                                    setWillDoLater(true);
                                    setDobChecked(true);
                                    setValues((values) => {
                                        if (productObj?.fullname) {
                                            values.fullname = productObj.fullname
                                        }
                                        if (productObj?.pan) {
                                            if (productObj?.isguradianpan) {
                                                values.gurdianPanNo = productObj.pan;
                                                values.minorPan = "no"
                                            } else {
                                                values.pan = productObj.pan;
                                                values.minorPan = "yes"
                                            }
                                        }

                                        if (productObj?.dob) {
                                            const formattedDob = moment(moment(convertDate(productObj?.dob)).toDate())
                                                .startOf("day")
                                                .toDate();
                                            // if (productObj?.isguradianpan)
                                            //     values.gurdianDOB = formattedDob
                                            // else
                                            values.dob = formattedDob;

                                            // Set senior citizen flag for main applicant only
                                            // if (ageCalculator(values.dob) > 60) {
                                            //     window.sessionStorage.setItem("isSeniorCitizen", "true");
                                            // } else {
                                            //     window.sessionStorage.setItem("isSeniorCitizen", "false");
                                            // }
                                        }
                                        if (productObj?.firstName) {
                                            values.firstName = productObj.firstName;
                                        }

                                        if (productObj?.middleName) {
                                            values.middleName = productObj.middleName;
                                        }

                                        if (productObj?.lastName) {
                                            values.lastName = productObj.lastName;
                                        }
                                        if (productObj?.leadid) {
                                            GlobalStore.leadId = productObj?.leadid;
                                        }
                                        if (productObj?.email) {
                                            GlobalStore.user.email = productObj?.email;
                                        }
                                        if (productObj?.mobile) {
                                            GlobalStore.user.mobile = productObj?.mobile;
                                        }
                                        if (productObj?.createdBy) {
                                            GlobalStore.user.rmCode = productObj?.createdBy;
                                        }
                                        if (productObj?.accountCategory) {
                                            GlobalStore.accountcategory = parseInt(
                                                productObj?.accountCategory
                                            );
                                            GlobalStore.user.accountType =
                                                parseInt(productObj?.accountCategory) == 2 ? "I" : "TD";
                                        }
                                        let PANFirstName = productObj?.firstName;
                                        let PANMiddleName = productObj?.middleName ?? "";
                                        let PANlastName = productObj?.lastName ?? "";

                                        if (PANFirstName === "" && PANlastName !== "") {
                                            PANFirstName = PANlastName;
                                            GlobalStore.personaldetails.PANName = PANFirstName;
                                            PANlastName = "";
                                            if (PANMiddleName !== "") {
                                                GlobalStore.personaldetails.PANName =
                                                    GlobalStore.personaldetails.PANName +
                                                    " " +
                                                    PANMiddleName;
                                            }
                                        } else if (
                                            PANFirstName === "" &&
                                            PANMiddleName === "" &&
                                            PANlastName === ""
                                        ) {
                                            GlobalStore.personaldetails.PANName = "";
                                        } else if (PANMiddleName === "") {
                                            GlobalStore.personaldetails.PANName =
                                                PANFirstName + " " + PANlastName;
                                            PANMiddleName = "";
                                        } else {
                                            GlobalStore.personaldetails.PANName =
                                                PANFirstName + " " + PANMiddleName + " " + PANlastName;
                                        }

                                        //Modify personal details based on this response.

                                        GlobalStore.personaldetails.firstname = PANFirstName;
                                        GlobalStore.personaldetails.lastname = PANlastName;
                                        GlobalStore.personaldetails.middlename = PANMiddleName;
                                        GlobalStore.personaldetails.panDetails = {
                                            PanNo: values.pan || values.gurdianPanNo,
                                            Firstname: PANFirstName,
                                            Middlename: PANMiddleName,
                                            Lastname: PANlastName,
                                            PANIssueDate: "",
                                            AadharSeedingStatus: "",
                                            VendorName: "",
                                            IsValid: true,
                                            IsAadharSeeded: "",
                                        };
                                        let reqObj: any = {
                                            pan: productObj.pan,
                                            accountType: productObj?.accountCategory,
                                            rmId: productObj?.createdBy,
                                        };
                                        let newReqObj = {
                                            rmid: productObj?.createdBy,
                                            skipUrlBoolean: true,
                                        };
                                        AgetClientDetailsByPANNew(reqObj, newReqObj);
                                        return values;
                                    });
                                    setPanFileUploaded(true);
                                }
                            }
                        }
                    },
                    {
                        id: encodeURIComponent(id),
                        name: encodeURIComponent(name),
                        stageFlag: 1,
                    }
                );
            }
        } else {
            if (!GlobalStore.user.email || !GlobalStore.user.mobile) {
                if (!!navigateURL) {
                    setSkipUrlBoolean(false);
                    window.location.href = navigateURL;
                }
            }
        }
    }, []);

    // Clervertap event: pan screen is loaded
    React.useEffect(() => {
        const data = {
            EventName: cleverTapEvents.registration.panPage.PAGE_LOAD,
            InitiationPlatform: "",
            UTM_SOURCE,
            UTM_MEDIUM,
            UTM_CAMPAIGN,
            LEAD_ID: GlobalStore.leadId,
            REF_ID: "",
        };
        ClevertapService.pushEvent(data);
    }, []);

    React.useEffect(() => {
        if (applicationModeType === "isKRA") {
            setModalDisplayText(
                "As per SEBI Regulations, under the Income Tax Guidelines we have successfully verified your Name on the Income Tax Website. Your application is pre-filled since you are an existing KRA Validated Customer."
            );
        } else if (applicationModeType === "isDigiLocker") {
            setModalDisplayText(
                "As per SEBI Regulations, under the Income Tax Guidelines we have successfully verified your Name on the Income Tax Website. We suggest completing your journey using Digilocker. For Using Digilocker your Aadhar and Mobile should be linked. It is not mandatory to have a Digilocker account. This will help you to speed up your activation process."
            );
        }
    }, [applicationModeType]);

    React.useEffect(() => {
        if (GlobalStore.user) {
            setValues((values) => {
                values.firstName = GlobalStore.user.firstname;
                values.lastName = GlobalStore.user.lastName
                values.middleName = GlobalStore.user.middleName
                return values
            })
        }
    }, [GlobalStore.user])

    const registerCleverTapEventAfterProceed = () => {
        const data = {
            EventName: cleverTapEvents.registration.panPage.CLICK_ON_PROCEED,
            InitiationPlatform: "",
            UTM_SOURCE,
            UTM_MEDIUM,
            UTM_CAMPAIGN,
            LEAD_ID: GlobalStore.leadId,
            REF_ID: GlobalStore.applicationID,
            KRA: GlobalStore.isKRA,
            ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
        };
        ClevertapService.pushEvent(data);

        // Apps flyer event for click on proceed on pan details page
        AppsFlyerService.pushEvent(
            appsFlyerEvents.registration.panPage.CLICK_ON_PROCEED
        );
        mixpanelService({
            event: webFlowEvents.pan.SUCCESS,
            account_type: "minor",
            kra: GlobalStore.isKRA,
            aadhar_linked_with_mobile: GlobalStore.aadharLinkedChoice,
        });
    };

    function init() {
        //CleverTap log start
        /*
            var data = {
                CurrentPage: $location.path(),
                Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
                EventName: 'Pan_dob_view'
            };
            clevertap.event.push(data.EventName, data);
            */
        //CleverTap log end

        window.sessionStorage.setItem("isSeniorCitizen", "false");
        window.sessionStorage.removeItem("isAadhaarVerified");
        GlobalStore.personaldetails = {
            firstname: GlobalStore.user.firstname,
            lastname: GlobalStore.user.lastName,
            middlename: "",
            mobile: GlobalStore.user.mobile,
            emailId: GlobalStore.user.email,
            aadhaar: "",
            pan: "",
            gender: "",
            dob: "",
            additionalemail: "",
            additionalmobile: "",
            PANName: "",
            adrLine1: "",
            adrLine2: "",
            city: "",
            state: "",
            pincode: "",
        };
    }

    function onChange(key: keyof IPanDobFields, value: string | Date) {
        if (key == 'minorPan') {
            values.pan = ""
            errors.pan = ""
        }
        if (
            key === "pan" &&
            typeof value === "string" &&
            !alphaNumExp.test(value)
        ) {
            value = values[key];
        }
        if (key === "pan") setValidPan(false);
        if (key === "aadharLinked" && typeof value === "string")
            gtmService({
                action: "PAN_DOB",
                label: `AADHAR_LINK | ${value.toUpperCase()}`,
            });
        if (key === "dob" && typeof value !== "string") {
            setErrCode(errCode);
            if (ageCalculator(value) >= 60)
                window.sessionStorage.setItem("isSeniorCitizen", "true");
            else window.sessionStorage.setItem("isSeniorCitizen", "false");
            if (moment(value).format("YYYY-MM-DD") === panDobState) {
                setDobChecked(true);
                setRemovePanImg(false);
                setErrCode("");
            } else {
                setDobChecked(false);
            }
        }
        if (key === 'dob' && entityType == 'NONINDIVIDUAL') {
            GlobalStore.dateOfIncorporation = moment(value).format('YYYY-MM-DD')
        }
        setErrors({ ...errors, [key]: "" });
        setValues({ ...values, [key]: value });
    }

    function onBlurPan(error: any) {
        if (values.pan) {
            setErrors({
                ...errors,
                pan: error.pattern ? "" : errorMsg(errorCode.FE07),
            });
        } else {
            setErrors({
                ...errors,
                pan: error.pattern ? "" : errorMsg(errorCode.FE09),
            });
        }
    }

    function onBlurPanMinor(error: any) {
        if (values.gurdianPanNo) {
            setErrors({
                ...errors,
                gurdianPanNo: error.pattern ? "" : errorMsg(errorCode.FE07),
            });
        } else {
            setErrors({
                ...errors,
                gurdianPanNo: error.pattern ? "" : errorMsg(errorCode.FE09),
            });
        }
    }

    function onBlurDob(event: React.FocusEvent<HTMLInputElement>) {
        if (!values.dob) {
            // setErrors({ ...errors, dob: 'Please select a valid date' });
            setErrors({ ...errors, dob: errorMsg(errorCode.FE10) });
        }
    }
    const UccCheckNewCalled = (res: any, callBackFunction: Function) => {
        if (!res || res?.error) {
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }

            setIsLoading(false);
            gtmService({ action: "CheckUCCExists", label: "ERROR || ERR105" });
            mixpanelService({
                event: mixpanelEvents.ERROR_TRIGGERED,
                screen_name: getScreenName(window.location.pathname),
                error_object: res?.error,
            });
        } else {
            if (
                !!res?.data &&
                res?.data?.Source === 1 &&
                res?.data?.IbeatsCheck !== null &&
                res?.data?.IbeatsCheck !== undefined &&
                res?.data?.IbeatsCheck
            ) {
                registerCleverTapEventAfterProceed();
                gtmService({ action: "PAN_DOB", label: "Step_Complete" });
                // history.push(containerUrl.accexists);
                navigate(containerUrl.accexists)
                setIsLoading(false);
            } else if (
                !!res?.data &&
                res?.data?.Source === 2 &&
                res?.data?.UccCheck !== null &&
                res?.data?.UccCheck !== undefined &&
                res?.data?.UccCheck
            ) {
                callBackFunction();
            }
        }
    };
    const panFunction = () => {
        panValidation(
            {
                panNo: values.pan || values?.gurdianPanNo,
                name: entityType == "NONINDIVIDUAL" ? values.fullname : values.pan ?
                    values.firstName +
                    " " +
                    (values?.middleName ?? "" + " ") +
                    values.lastName : values.gurdianFName +
                    " " +
                    (values?.gurdianMName ?? "" + " ") +
                    values.gurdianLName,
                dob: values.pan ? moment(values.dob).format("DD/MM/YYYY") : moment(values.gurdianDOB).format("DD/MM/YYYY"),
                source: "DIY",
            },
            () => { }
        );
    };

    function handleSubmit(e?: any) {
        e.preventDefault();  // ✅ THIS STOPS PAGE RELOAD


        // Reset state
        setErrCode("");
        setIsLoading(true);
        setSubmitFlag(false);

        const {
            pan,
            gurdianPanNo,
            dob,
            gurdianDOB
        } = values;
        const activePan: any = pan || gurdianPanNo;
        const activeDob = dob;
        const isValidPan = panRegex.test(activePan);

        // --- Validation ---
        if (entitySubType == 'Minor') {
            if (!values.gurdianFName || !values.gurdianDOB || !values.gurdianPanNo) {
                setErrCode("Please fill all the Guardian details");
                return setIsLoading(false);
            }
            if (values.gurdianPanNo === values.pan) {
                setErrCode("Guardian Pan and minor pan cannot be the same");
                return setIsLoading(false);
            }
        }


        if (!activePan || !isValidPan) {
            setErrCode("Invalid PAN");
            return setIsLoading(false);
        }

        // --- Check for minor ---
        if (isMinor(entitySubType == "Minor" ? gurdianDOB : dob)) {
            setErrCode("The PAN belongs to a minor.");
            return setIsLoading(false);
        }

        const accountType = getProductCode() === "I" ? 2 : 1;

        const proceedAfterPan = () => {
            AGetEmployeeByPan(checkIsPanEmployee, values.pan || values.gurdianPanNo);

            let body: {
                name?: string | null,
                dob?: any | null,
                guardianPanNo?: string | null
            } = {
                name: null,
                dob: null,
                guardianPanNo: null
            }

            if (GlobalStore.entitySubType == "Minor") {
                body.name = `${values.firstName} ${values.middleName || ""} ${values.lastName}`
                body.dob = moment(dob).format('MM/DD/YYYY')
                body.guardianPanNo = values.gurdianPanNo
            }
            ACheckUCCExists(
                (res: any) => {
                    UccCheckNewCalled(res, panFunction);
                },
                values.pan || values.gurdianPanNo,
                GlobalStore.user.mobile,
                GlobalStore.user.email,
                GlobalStore.leadId,
                prodObj?.createdBy ? parseInt(prodObj.createdBy) : 0,
                accountType,
                getProductCode(),
                body.name,
                body.dob,
                body.guardianPanNo
            );
        };

        const clientPartialDetails_ao = JSON.parse(
            localStorageGetItem("clientPartialDetails_ao") || "{}"
        );

        ACheckKraPan(
            (res: any) => {
                const isKraValid = res?.data?.IsKra;
                const isGuardianKraValid = res?.data?.IsGuardianKra;

                if (isKraValid && isGuardianKraValid) {
                    setValidPan(true);
                    setPanInvalidMsg("");
                    proceedAfterPan();
                } else {
                    setValidPan(false);
                    setIsLoading(false);
                    if (!isKraValid)
                        setPanInvalidMsg(res?.data?.strKra);
                    else
                        setPanInvalidMsg(res?.data?.strGuardianKra);
                }
            },
            pan,
            moment(dob).format("DD/MM/YYYY"),
            clientPartialDetails_ao?.emailID || prodObj?.email || GlobalStore.user.email,
            clientPartialDetails_ao?.mobile || prodObj?.mobile || GlobalStore.user.mobile,
            GlobalStore.applicationID,
            gurdianPanNo,
            moment(gurdianDOB).format("DD/MM/YYYY"),
            entitySubType
        );
    }


    function checkIsPanEmployee(res: any) {
        if (res && res.status) {
            const responseDataObj = res.data;
            if (responseDataObj.result.Flag === "Y") isEmployee = true;
        } else {
            if (!res || res?.error) {
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                gtmService({
                    action: "GetEmployeeDetailsByPAN",
                    label: "ERROR || ERR109",
                });
            }
        }
    }

    function checkPendingUploadNew(res: any, reqObj?: any) {
        let dematAccountFoundLocal: any = null;
        if (!res || res?.error) {
            // setErrCode('1221 - Error in fetching pending document upload list.');
            //   setErrCode(errorMessage.checkPendingUpload);
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR112" });
            setIsLoading(false);
        } else {
            if (res && res?.data == null) {
                let isUploadDocumentsCompleted: boolean = false;
                AGetStageCompletionStatus(
                    (res: any) =>
                        getClientStageDetailsNew(res, isUploadDocumentsCompleted, reqObj),
                    GlobalStore.applicationID
                );
            } else if (res && res.data !== null) {
                const list: Array<any> = JSON.parse(res.data).filter(
                    (item: any) => item.Mandatory == true
                );
                let isUploadDocumentsCompleted: boolean = false;
                if (
                    list !== undefined &&
                    list !== null &&
                    list?.length > 0 &&
                    list?.length === 1
                ) {
                    dematAccountFoundLocal = list.find(
                        (listObj) =>
                            listObj?.DocumentCategory == "DP Document" &&
                            listObj?.DocumentCategoryId == 96
                    );
                    if (
                        dematAccountFoundLocal !== undefined &&
                        dematAccountFoundLocal !== null
                    ) {
                        setDematAccountFound((dematAccountFound: any) => {
                            dematAccountFound = dematAccountFoundLocal;
                            return dematAccountFound;
                        });
                        //  completeModuleStatus(dashboardUrl.demat);
                        // history.push(dashboardUrl.demat);
                        // return;
                    }
                }
                if (
                    list !== undefined &&
                    list !== null &&
                    list?.length > 0 &&
                    list?.length > 1
                ) {
                    dematAccountFoundLocal = list.find(
                        (listObj) =>
                            listObj?.DocumentCategory == "DP Document" &&
                            listObj?.DocumentCategoryId == 96
                    );
                    if (
                        dematAccountFoundLocal !== undefined &&
                        dematAccountFoundLocal !== null
                    ) {
                        setDematAccountFound((dematAccountFound: any) => {
                            dematAccountFound = dematAccountFoundLocal;
                            return dematAccountFound;
                        });
                        //  completeModuleStatus(dashboardUrl.demat);
                        // history.push(dashboardUrl.demat);
                        // return;
                    }
                }
                if (list.length === 0 || list[0].count === 0)
                    isUploadDocumentsCompleted = true;

                AGetStageCompletionStatus(
                    (res: any) =>
                        getClientStageDetailsNew(
                            res,
                            isUploadDocumentsCompleted,
                            reqObj,
                            dematAccountFoundLocal
                        ),
                    GlobalStore.applicationID
                );
            } else {
                // setErrCode('1222 - Error in fetching pending document upload list.');
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                setIsLoading(false);
            }
        }
    }
    const getCheckedDobCondition = () => {
        let disabledCondition: boolean = false;
        if (
            prodObj?.createdBy !== null &&
            prodObj?.createdBy !== undefined &&
            prodObj?.createdBy !== 0 &&
            prodObj?.dob != undefined &&
            prodObj?.dob !== null &&
            prodObj?.dob !== "" &&
            values?.dob !== null &&
            values?.dob !== undefined &&
            values?.dob ===
            moment(moment(convertDate(prodObj?.dob)).toDate())
                .startOf("day")
                .toDate()
        ) {
            disabledCondition = true;
        }
        return disabledCondition;
    };
    function getClientStageDetailsNew(
        res: any,
        isUploadDocumentsCompleted: boolean,
        reqObj?: any,
        dematAccountFoundLocaL?: any
    ) {
        if (!res || res?.error) {
            // setErrCode('1061 - Error in fetching stage completion details.');
            // setErrCode(errorMessage.getClientStageDetails);
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({
                action: "GetStageCompletionStatus",
                label: "ERROR || ERR113",
            });
            setIsLoading(false);
        } else {
            if (res.data && res.data !== null) {
                const responseObj = JSON.parse(res.data);
                const clientPartialDetails_ao = JSON.parse(
                    localStorageGetItem("clientPartialDetails_ao") || "{}"
                );
                setStageData(responseObj);
                //check completeness of stages
                checkModuleCompleteness(
                    isUploadDocumentsCompleted,
                    dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
                );

                if (!clientPartialDetails_ao.mobile) {
                    clientPartialDetails_ao.mobile = responseObj.mobileno;
                }

                if (!clientPartialDetails_ao.emailID) {
                    clientPartialDetails_ao.emailID = responseObj.emailid;
                }
                clientPartialDetails_ao.pan = GlobalStore.personaldetails.pan;

                clientPartialDetails_ao.clientPrimaryDetailId =
                    GlobalStore.clientPrimaryDetailId;
                clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
                clientPartialDetails_ao.accountcategory = GlobalStore.accountcategory;
                clientPartialDetails_ao.token = GlobalStore.token;
                if (
                    responseObj?.fatherspousename != null &&
                    responseObj?.fatherspousename != undefined &&
                    responseObj?.fatherspousename !== ""
                ) {
                    clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
                }
                clientPartialDetails_ao.dpid = responseObj?.dpid;
                clientPartialDetails_ao.clientid = responseObj?.dpclientid;
                GlobalStore.dpid = responseObj?.dpid;
                GlobalStore.clientid = responseObj?.dpclientid;
                GlobalStore.entityType = responseObj?.entitytype;
                GlobalStore.entitySubType = responseObj?.entitysubtype
                localStorageSetItem(
                    "clientPartialDetails_ao",
                    JSON.stringify(clientPartialDetails_ao)
                );
                //set stage api data to GlobalStore
                setStageData(responseObj);
                let cacheData = null;
                //check completeness of stages
                checkModuleCompleteness(
                    isUploadDocumentsCompleted,
                    dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
                );
                setCheckpanaaddharflag(responseObj.checkpanaaddharflag);
                setStageBooleanFlags((stageBooleanFlags) => {
                    stageBooleanFlags.isPersonalStage =
                        responseObj?.ispersonaldetailscompleted;
                    stageBooleanFlags.isProfileStage =
                        responseObj?.isprofiledetailscompleted;
                    return stageBooleanFlags;
                });

                if (
                    reqObj?.skipUrlBoolean &&
                    reqObj?.rmid !== null &&
                    reqObj?.rmid !== undefined
                ) {
                    if (
                        !(
                            responseObj.isprofiledetailscompleted &&
                            responseObj.ispersonaldetailscompleted
                        )
                    ) {
                    }
                    GlobalStore.nextIncompleteStage = dashboardUrl.profile;
                }

                if (responseObj.iskyc) GlobalStore.isKYC = true;

                if (
                    !(
                        responseObj.isprofiledetailscompleted &&
                        responseObj.ispersonaldetailscompleted
                    )
                ) {
                    GlobalStore.nextIncompleteStage = dashboardUrl.profile;
                } else if (!responseObj.isbankdetailscompleted) {
                    GlobalStore.nextIncompleteStage = dashboardUrl.bank;
                } else if (
                    responseObj?.accountcategory === 2 &&
                    !responseObj?.isdpcompleted
                )
                    GlobalStore.nextIncompleteStage = dashboardUrl.demat;
                else if (!isUploadDocumentsCompleted)
                    GlobalStore.nextIncompleteStage = dashboardUrl.doc;
                else if (
                    responseObj.applicationstatus === 1 &&
                    responseObj.bpm_pd_status === 0
                )
                    // history.push(statusUrl.docVerificationInProgress);
                    navigate(statusUrl.docVerificationInProgress)
                else if (responseObj.bpm_pd_status === 1)
                    // history.push(containerUrl.poa);
                    navigate(containerUrl.poa)
                let newReqObj = reqObj;
                newReqObj.isKra = responseObj.iskra;
                if (!isUploadDocumentsCompleted && responseObj.bpm_pd_status === 2) {
                    // history.push(statusUrl.documentReject);
                    navigate(statusUrl.documentReject)
                    return;
                } else if (
                    isUploadDocumentsCompleted == true &&
                    responseObj.bpm_pd_status === 2
                ) {
                    QCServiceTaskCreation(
                        (res: any) => {
                            if (!res || res?.error) {
                                setIsLoading(false);
                                setErrCode(res?.error);
                            } else {
                                if (
                                    res &&
                                    res.data !== null &&
                                    Object.keys(res?.data)?.length > 0
                                ) {
                                    // history.push(statusUrl.docVerificationInProgress);
                                    navigate(statusUrl.docVerificationInProgress)
                                    return
                                } else {
                                    setErrCode("Something went wrong. please try again later.");
                                    setIsLoading(false);
                                }
                            }
                        },
                        GlobalStore?.applicationID,
                        GlobalStore.stageStatus.accountcategory
                            ? GlobalStore?.stageStatus?.accountcategory
                            : 0
                    );
                }
                if (
                    reqObj?.skipUrlBoolean &&
                    reqObj?.rmid !== null &&
                    reqObj?.rmid !== undefined &&
                    responseObj.applicationstatus === 1 &&
                    responseObj.bpm_pd_status === 0
                ) {
                    // history.push(statusUrl.docVerificationInProgress);
                    navigate(statusUrl.docVerificationInProgress)
                } else if (
                    reqObj?.skipUrlBoolean &&
                    reqObj?.rmid !== null &&
                    reqObj?.rmid !== undefined &&
                    responseObj.applicationstatus === 1 &&
                    responseObj.bpm_pd_status === 1
                ) {
                    if (
                        responseObj.isesigncompleted !== null &&
                        responseObj.isesigncompleted == true &&
                        responseObj?.auth_ver &&
                        responseObj?.accountcategory === 2 &&
                        responseObj?.elog_opted &&
                        responseObj.isKra
                    ) {
                        // history.push(statusUrl.elogVerificationInProgress);
                        navigate(statusUrl.elogVerificationInProgress)
                    } else if (
                        responseObj.isesigncompleted !== null &&
                        responseObj.isesigncompleted == true &&
                        responseObj?.auth_ver &&
                        responseObj?.accountcategory === 2
                    ) {
                        // history.push(containerUrl.esignsubmit);
                        navigate(containerUrl.esignsubmit)
                    } else {
                        if (
                            responseObj.iskra !== null &&
                            responseObj.iskra !== undefined &&
                            responseObj?.auth_ver
                        ) {
                            // history.push(containerUrl.kycsubmit);
                            navigate(containerUrl.kycsubmit)
                            // } else history.push(containerUrl.kycsubmit);
                        } else navigate(containerUrl.kycsubmit)
                    }
                } else savePanDob(true, true, newReqObj);
            } else {
                // setErrCode('1062 - Error in fetching stage completion details.');
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                setIsLoading(false);
            }
        }
    }
    const AgetClientDetailsByPANNew = (reqObj: any, newReqObj?: any) => {
        AGetClientDetailsByPan(
            (res: any) => {
                if (!res || res?.error) {
                    // setErrCode('118 - Error in fetching Client details from our system.');
                    // setErrCode(errorMessage.searchByPan);
                    if (errCode?.includes(res?.error)) {
                        setErrCode(errCode);
                    } else {
                        setErrCode(errCode + res?.error);
                    }
                    gtmService({
                        action: "GetClientDataByPanOrLead",
                        label: "ERROR || ERR102",
                    });
                    setIsLoading(false);
                } else {
                    if (res.data !== null) {
                        if (res.data !== null && res.data != "Records Not Found") {
                            GlobalStore.personaldetails.pan = res.data.PAN;
                            GlobalStore.token = res.data.Token;
                            GlobalStore.applicationID = res.data.ApplicatoinId;
                            GlobalStore.leadId = res.data.LeadId;
                            GlobalStore.accountcategory = res.AccountCategory;
                            GlobalStore.clientPrimaryDetailId =
                                res.data.ClientPrimaryDetailId;
                            const clientPartialDetails_ao = JSON.parse(
                                localStorageGetItem("clientPartialDetails_ao") || "{}"
                            );
                            clientPartialDetails_ao.pan = res.data.Token;
                            clientPartialDetails_ao.clientPrimaryDetailId =
                                res.ClientPrimaryDetailId;
                            clientPartialDetails_ao.applicationId = res.ApplicatoinId;
                            clientPartialDetails_ao.accountcategory = res.AccountCategory;
                            clientPartialDetails_ao.token = res.data.Token;
                            localStorageSetItem(
                                "clientPartialDetails_ao",
                                JSON.stringify(clientPartialDetails_ao)
                            );
                            APendingUploadList((res: any) => {
                                checkPendingUploadNew(res, newReqObj);
                            }, GlobalStore.applicationID);
                        }
                    } else {
                        // setErrCode('1182 - Error in fetching Client details from our system.');
                        if (errCode?.includes(res?.error)) {
                            setErrCode(errCode);
                        } else {
                            setErrCode(errCode + res?.error);
                        }
                        setIsLoading(false);
                    }
                }
            },
            reqObj.pan,
            reqObj.accountType,
            reqObj.rmId
        );
    };
    const validatePANNew = (
        seedingStatus?: string,
        SeedingStatusMsg?: string,
        PanStatus?: string
    ) => {
        let PANFirstName = values?.firstName;
        let PANMiddleName = values.middleName ?? "";
        let PANlastName = values?.lastName ?? "";

        if (PANFirstName === "" && PANlastName !== "") {
            PANFirstName = PANlastName;
            GlobalStore.personaldetails.PANName = PANFirstName;
            PANlastName = "";
            if (PANMiddleName !== "") {
                GlobalStore.personaldetails.PANName =
                    GlobalStore.personaldetails.PANName + " " + PANMiddleName;
            }
        } else if (
            PANFirstName === "" &&
            PANMiddleName === "" &&
            PANlastName === ""
        ) {
            GlobalStore.personaldetails.PANName = "";
        } else if (PANMiddleName === "") {
            GlobalStore.personaldetails.PANName = PANFirstName + " " + PANlastName;
            PANMiddleName = "";
        } else {
            GlobalStore.personaldetails.PANName =
                PANFirstName + " " + PANMiddleName + " " + PANlastName;
        }
        if (seedingStatus === "N") {
            GlobalStore.isSeeding = false;
        } else {
            GlobalStore.isSeeding = true;
        }
        let accountType = getProductCode() == "I" ? 2 : 1;
        if (getProductCode() == "I") {
            accountType = 2;
        }
        AGetClientDetailsByPan(
            searchByPan,
            values.pan || values?.gurdianPanNo,
            accountType,
            skipUrlBoolean &&
                prodObj?.createdBy != null &&
                prodObj?.createdBy !== undefined
                ? prodObj?.createdBy
                : GlobalStore?.user?.userId,
            values?.firstName || "",
            values?.middleName || "",
            values?.lastName || "",
            values?.dob ? moment(values.dob).format("DD/MM/YYYY") : ""
        );
        //ACheckPanIbeats(checkedPanInIbeats, values.pan);
    };

    function searchByPan(res: any) {
        if (!res || res?.error) {
            // setErrCode('118 - Error in fetching Client details from our system.');
            // setErrCode(errorMessage.searchByPan);
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({
                action: "GetClientDataByPanOrLead",
                label: "ERROR || ERR102",
            });
            setIsLoading(false);
        } else {
            if (res.data !== null) {
                if (res.data !== null && res.data != "Records Not Found") {
                    GlobalStore.personaldetails.pan = res.data.PAN;
                    GlobalStore.token = res.data.Token;
                    GlobalStore.applicationID = res.data.ApplicatoinId;
                    GlobalStore.leadId = res.data.LeadId;
                    GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
                    GlobalStore.accountcategory = res.AccountCategory;
                    APendingUploadList(checkPendingUpload, GlobalStore.applicationID);
                } else {
                    savePanDob();
                }
            } else if (res.data === null) {
                savePanDob();
            } else {
                // setErrCode('1182 - Error in fetching Client details from our system.');
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                setIsLoading(false);
            }
        }
    }

    const cacheKRAFunction = (
        responseObj: any,
        skipSavePANDOB?: boolean,
        reqObj?: any
    ) => {
        GlobalStore.isKRA = true;
        if (applicationModeType !== "isKRA") {
            setApplicationModeType("isKRA");
        }
        const clientPartialDetails_ao = JSON.parse(
            localStorageGetItem("clientPartialDetails_ao") || "{}"
        );
        GlobalStore.KRA_email = responseObj.KraEmail ? responseObj.KraEmail : "";
        GlobalStore.KRA_mobile = responseObj.KraMobile ? responseObj.KraMobile : "";
        GlobalStore.KRA_mode = responseObj.kra_mode ? responseObj.kra_mode : 0;

        // if (!GlobalStore.isKYC) {
        const resultObj = responseObj;
        GlobalStore.kraInfoObject.addressLine1 = `${resultObj.AppPerAdd1} ${resultObj.AppPerAdd2 || ""
            } ${resultObj.AppPerAdd3 || ""}`;
        GlobalStore.kraInfoObject.addressLine1 =
            GlobalStore.kraInfoObject.addressLine1; //.replace(/[^a-zA-Z0-9 ]/g, " ")

        GlobalStore.kraInfoObject.corrAddress = `${resultObj.AppCorAdd1} ${resultObj.AppCorAdd2 || ""
            } ${resultObj.AppCorAdd3 || ""}`;
        GlobalStore.kraInfoObject.corrAddress =
            GlobalStore.kraInfoObject.corrAddress; //.replace(/[^a-zA-Z0-9 ]/g, " ")
        GlobalStore.kraInfoObject.pincode = resultObj.AppPerPincd;
        GlobalStore.kraInfoObject.corrPincode = resultObj.AppCorPincd;
        GlobalStore.personaldetails.fsfullName = resultObj.FatherName
            ? resultObj.FatherName
            : GlobalStore.personaldetails.fsfullName;
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.gender = responseObj?.Gender;
        GlobalStore.personaldetails.gender = responseObj?.Gender;
        clientPartialDetails_ao.addressLine1 =
            GlobalStore.kraInfoObject.addressLine1;
        clientPartialDetails_ao.PinCode = GlobalStore.kraInfoObject.pincode;
        clientPartialDetails_ao.corrAddress = GlobalStore.kraInfoObject.corrAddress;
        clientPartialDetails_ao.corrPincode = GlobalStore.kraInfoObject.corrPincode;
        clientPartialDetails_ao.fsfullName = GlobalStore.personaldetails.fsfullName;
        clientPartialDetails_ao.sameAsPermanent =
            GlobalStore.kraInfoObject.addressLine1 ==
                GlobalStore.kraInfoObject.corrAddress
                ? true
                : false;
        // } else {
        //     clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        // }'
        if (skipSavePANDOB) {
            clientPartialDetails_ao.pan = GlobalStore?.personaldetails.pan;
            clientPartialDetails_ao.clientPrimaryDetailId =
                GlobalStore?.clientPrimaryDetailId;
            clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
            clientPartialDetails_ao.accountcategory = GlobalStore?.accountcategory;
            clientPartialDetails_ao.token = GlobalStore?.token;
            clientPartialDetails_ao.leadID = GlobalStore.leadId;
        }
        localStorageSetItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
        );
        GlobalStore.dateofbirth = moment(values.dob).format("MM/DD/YYYY");
        GlobalStore.dateOfIncorporation = moment(values.dob).format("YYYY-MM-DD");
        if (skipSavePANDOB) {
            menuOption(reqObj, () => {
                // history.push(dashboardUrl.profile);
                navigate(dashboardUrl.profile)
            });
        } else dobMatched({}, true, true);
        // getKraDocumentUpload(responseObj, true);
        // setTimeout(()=>{

        // },3000)
    };
    const menuOption = (reqObj?: any, redirctTo?: Function) => {
        if (
            reqObj.skipUrlBoolean &&
            reqObj?.rmid !== null &&
            reqObj?.rmid !== undefined
        ) {
            if (!reqObj?.isKra || isPanLinkedToAadhar !== true) {
                let filterLeftBar = [...leftNavBarArray];
                let filterNavIndex = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == "/plan"
                );
                if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
                let filterNavIndex2 = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == dashboardUrl.eSign
                );
                if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
                let filterNavIndex3 = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == dashboardUrl.profiler
                );
                if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
                let filterNavIndex4 = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == dashboardUrl.ipv
                );
                if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
                if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
                    filterLeftBar.push(dematNavBarObj);
                // GlobalStore.leftNavBarState = filterLeftBar;
            } else {
                setDobChecked(true);
                let filterLeftBar = [...leftNavBarArray];
                let filterNavIndex = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == "/plan"
                );
                if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
                let filterNavIndex2 = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == dashboardUrl.eSign
                );
                if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
                let filterNavIndex3 = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == dashboardUrl.profiler
                );
                if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
                let filterNavIndex4 = filterLeftBar?.findIndex(
                    (filter) => filter?.navUrl == dashboardUrl.ipv
                );
                if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
                if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
                    filterLeftBar.push(dematNavBarObj);
                // GlobalStore.leftNavBarState = filterLeftBar;
            }
            if (redirctTo !== undefined) redirctTo();
        }
    };
    const originalSavePANDOB = (
        applicationIdExists?: boolean,
        skipSavePANDOB?: boolean,
        reqObj?: any
    ) => {
        if (
            applicationIdExists &&
            (GlobalStore.stageStatus.ispersonaldetailscompleted ||
                GlobalStore.stageStatus.isprofiledetailscompleted)
        ) {
            const clientPartialDetails_ao = JSON.parse(
                localStorageGetItem("clientPartialDetails_ao") || "{}"
            );

            clientPartialDetails_ao.PANName = GlobalStore.personaldetails.PANName;
            clientPartialDetails_ao.aadharLinkedChoice =
                GlobalStore.aadharLinkedChoice;
            clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
            clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
            clientPartialDetails_ao.ckycNo = GlobalStore.stageStatus.ckycnumber;
            clientPartialDetails_ao.clientPrimaryDetailId =
                GlobalStore.clientPrimaryDetailId;
            clientPartialDetails_ao.dob = GlobalStore.dob;
            clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
            clientPartialDetails_ao.emailID = GlobalStore.user.email;
            clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
            clientPartialDetails_ao.isKRA = GlobalStore.stageStatus.iskra;
            clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;

            clientPartialDetails_ao.isSeniorCitizen =
                window.sessionStorage.getItem("isSeniorCitizen") === "true"
                    ? true
                    : false;
            clientPartialDetails_ao.leadID = GlobalStore.leadId;
            clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
            clientPartialDetails_ao.pan = values.pan || values.gurdianPanNo;
            clientPartialDetails_ao.panDetails =
                GlobalStore.personaldetails.panDetails;
            clientPartialDetails_ao.token = GlobalStore.token;
            clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
            // if(GlobalStore?.applicationID && GlobalStore?.isDigiLocker){
            //   setShowSubmitModal(true);
            // }
            localStorageSetItem(
                "clientPartialDetails_ao",
                JSON.stringify(clientPartialDetails_ao)
            );
            registerCleverTapEventAfterProceed();
            gtmService({ action: "PAN_DOB", label: "Step_Complete" });
            if (GlobalStore?.applicationID && GlobalStore?.isDigiLocker) {
                // history.push(GlobalStore?.nextIncompleteStage);
                navigate(GlobalStore?.nextIncompleteStage)
            } else {
                if (skipSavePANDOB) {
                    menuOption(reqObj, () => {
                        navigateTo(applicationIdExists, reqObj);
                    });
                } else navigateTo(applicationIdExists);
            }
        } else {
            GlobalStore.dateofbirth = moment(values.dob).format("MM/DD/YYYY");
            GlobalStore.dob = moment(values.dob).format("MM/DD/YYYY");
            GlobalStore.dateOfIncorporation = moment(values.dob).format("YYYY-MM-DD");
            GlobalStore.birthDate = moment(values.dob).format("MM/DD/YYYY");
            if (skipSavePANDOB) {
                let clientPartialDetails_ao = JSON.parse(
                    localStorageGetItem("clientPartialDetails_ao") || "{}"
                );
                clientPartialDetails_ao = {
                    clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
                    token: GlobalStore.token,
                    applicationId: GlobalStore.applicationID,
                    dob: GlobalStore.dob,
                    dateOfIncorporation: GlobalStore.dateOfIncorporation,
                    birthDate: GlobalStore.birthDate,
                    pan: values.pan || values.gurdianPanNo,
                    aadharLinkedChoice: GlobalStore.aadharLinkedChoice,
                    leadID: GlobalStore.leadId,
                    emailID: GlobalStore.user.email,
                    mobile: GlobalStore.user.mobile,
                    panDetails: GlobalStore.personaldetails.panDetails,
                    PANName: GlobalStore.personaldetails.PANName,
                    isSeniorCitizen:
                        window.sessionStorage.getItem("isSeniorCitizen") === "true"
                            ? true
                            : false,
                    isDigiLocker: GlobalStore.isDigiLocker,
                    isKRA: false,
                    isKYC: false,
                    isSeeding: GlobalStore.isSeeding,
                    selfieUrl: GlobalStore.selfieUrl,
                    isManual: false,
                    aadharNo: GlobalStore.personaldetails.aadharNo,
                    addressLine1: GlobalStore.addressLine1,
                    corrAddress: GlobalStore.corrAddress,
                    PinCode: GlobalStore.PinCode,
                    corrPincode: GlobalStore.corrPincode,
                    sameAsPermanent: GlobalStore.sameAsPermanent,
                };
                localStorageSetItem(
                    "aadharNumber",
                    GlobalStore.personaldetails.aadharNo
                );
                localStorageSetItem(
                    "clientPartialDetails_ao",
                    JSON.stringify(clientPartialDetails_ao)
                );
                if (
                    reqObj.skipUrlBoolean &&
                    reqObj?.rmid !== null &&
                    reqObj?.rmid !== undefined
                ) {
                    if (!reqObj?.isKra || isPanLinkedToAadhar !== true) {
                        let filterLeftBar = [...leftNavBarArray];
                        let filterNavIndex = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == "/plan"
                        );
                        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
                        let filterNavIndex2 = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == dashboardUrl.eSign
                        );
                        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
                        let filterNavIndex3 = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == dashboardUrl.profiler
                        );
                        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
                        let filterNavIndex4 = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == dashboardUrl.ipv
                        );
                        if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
                        if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
                            filterLeftBar.push(dematNavBarObj);
                        // GlobalStore.leftNavBarState = filterLeftBar;
                    } else {
                        //  setShowSubmitModal(true);
                        setDobChecked(true);
                        // if (applicationModeType !== "isKRA") {
                        //   setApplicationModeType("isKRA");
                        // }
                        let filterLeftBar = [...leftNavBarArray];
                        let filterNavIndex = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == "/plan"
                        );
                        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
                        let filterNavIndex2 = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == dashboardUrl.eSign
                        );
                        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
                        let filterNavIndex3 = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == dashboardUrl.profiler
                        );
                        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
                        let filterNavIndex4 = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == dashboardUrl.ipv
                        );
                        if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
                        if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
                            filterLeftBar.push(dematNavBarObj);
                        // GlobalStore.leftNavBarState = filterLeftBar;
                    }
                }
                // if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
                setShowSubmitModal(true);
                // }
                navigateTo(applicationIdExists, reqObj);
            } else {
                if (isPanLinkedToAadhar == true) {
                    // AGetCkycNumber(
                    //   (res: any) => getCkycNumber(res, applicationIdExists),
                    //   values.pan
                    // );
                    dobMatched({});
                } else {
                    GlobalStore.isKYC = false;
                    GlobalStore.isKRA = false;
                    const clientPartialDetails_ao = JSON.parse(
                        localStorageGetItem("clientPartialDetails_ao") || "{}"
                    );
                    clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
                    clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
                    localStorageSetItem(
                        "clientPartialDetails_ao",
                        JSON.stringify(clientPartialDetails_ao)
                    );
                    dobMatched({});
                }
            }
        }
    };
    function savePanDob(
        applicationIdExists?: boolean,
        skipSavePANDOB?: boolean,
        reqObj?: any
    ) {
        if (
            GlobalStore?.applicationID &&
            GlobalStore.stageStatus.ispersonaldetailscompleted !== true &&
            GlobalStore.stageStatus.isprofiledetailscompleted !== true
        ) {
            AGetCacheData(
                (res: any) => {
                    if (
                        res &&
                        res.data &&
                        res?.data?.Result &&
                        res?.data?.Result.IsTaggingPresent
                    ) {
                        let cacheResponse = res?.data?.Result;
                        if (
                            GlobalStore?.applicationID &&
                            GlobalStore.stageStatus.ispersonaldetailscompleted !== true &&
                            GlobalStore.stageStatus.isprofiledetailscompleted !== true &&
                            cacheResponse !== null &&
                            cacheResponse?.IsTaggingPresent
                        ) {
                            if (cacheResponse?.TaggingMode == "1") {
                                cacheKRAFunction(cacheResponse?.Data, skipSavePANDOB, reqObj);
                            } else if (cacheResponse?.TaggingMode == "2") {
                                GlobalStore.isDigiLocker = true;

                                const clientPartialDetails_ao = JSON.parse(
                                    localStorageGetItem("clientPartialDetails_ao") || "{}"
                                );
                                clientPartialDetails_ao.PANName =
                                    GlobalStore.personaldetails.PANName;
                                clientPartialDetails_ao.aadharLinkedChoice =
                                    GlobalStore.aadharLinkedChoice;
                                clientPartialDetails_ao.applicationId =
                                    GlobalStore.applicationID;
                                clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
                                clientPartialDetails_ao.ckycNo =
                                    GlobalStore.stageStatus.ckycnumber;
                                clientPartialDetails_ao.clientPrimaryDetailId =
                                    GlobalStore.clientPrimaryDetailId;
                                clientPartialDetails_ao.dob = GlobalStore.dob;
                                clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
                                clientPartialDetails_ao.emailID = GlobalStore.user.email;
                                clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
                                clientPartialDetails_ao.isKRA = GlobalStore.stageStatus.iskra;
                                clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;

                                clientPartialDetails_ao.isSeniorCitizen =
                                    window.sessionStorage.getItem("isSeniorCitizen") === "true"
                                        ? true
                                        : false;
                                clientPartialDetails_ao.leadID = GlobalStore.leadId;
                                clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
                                clientPartialDetails_ao.pan = values.pan || values.gurdianPanNo;
                                clientPartialDetails_ao.panDetails =
                                    GlobalStore.personaldetails.panDetails;
                                clientPartialDetails_ao.token = GlobalStore.token;
                                clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
                                clientPartialDetails_ao.signzydt = "";

                                localStorageSetItem(
                                    "clientPartialDetails_ao",
                                    JSON.stringify(clientPartialDetails_ao)
                                );
                                getProfileDetailsFromAadhar(cacheResponse?.Data);
                                if (skipSavePANDOB) menuOption();
                                // history.push(dashboardUrl.profile);
                                navigate(dashboardUrl.profile)
                            } else if (cacheResponse?.TaggingMode == "3") {
                                GlobalStore.isNormalClient = true;
                                GlobalStore.isKYC = false;
                                GlobalStore.isKRA = false;
                                const clientPartialDetails_ao = JSON.parse(
                                    localStorageGetItem("clientPartialDetails_ao") || "{}"
                                );
                                clientPartialDetails_ao.PANName =
                                    GlobalStore.personaldetails.PANName;
                                clientPartialDetails_ao.aadharLinkedChoice =
                                    GlobalStore.aadharLinkedChoice;
                                clientPartialDetails_ao.applicationId =
                                    GlobalStore.applicationID;
                                clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
                                clientPartialDetails_ao.ckycNo =
                                    GlobalStore.stageStatus.ckycnumber;
                                clientPartialDetails_ao.clientPrimaryDetailId =
                                    GlobalStore.clientPrimaryDetailId;
                                clientPartialDetails_ao.dob = GlobalStore.dob;
                                clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
                                clientPartialDetails_ao.emailID = GlobalStore.user.email;
                                clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
                                clientPartialDetails_ao.addressLine1 =
                                    cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine1;
                                clientPartialDetails_ao.addressLine1 +=
                                    cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine2;
                                clientPartialDetails_ao.addressLine1 +=
                                    cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine3;
                                clientPartialDetails_ao.addressLine1 +=
                                    cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine4;
                                clientPartialDetails_ao.sameAsPermanent =
                                    cacheResponse?.Data.corrsaddraspermanent !== null &&
                                        cacheResponse?.Data.corrsaddraspermanent !== undefined
                                        ? cacheResponse?.Data.corrsaddraspermanent
                                        : true;
                                clientPartialDetails_ao.corrAddress =
                                    cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine1;
                                clientPartialDetails_ao.corrAddress +=
                                    cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine2;
                                clientPartialDetails_ao.corrAddress +=
                                    cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine3;
                                clientPartialDetails_ao.corrAddress +=
                                    cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine4;
                                GlobalStore.addressLine1 = clientPartialDetails_ao.addressLine1;
                                GlobalStore.corrAddress = clientPartialDetails_ao.corrAddress;
                                GlobalStore.PinCode =
                                    cacheResponse?.Data.PermanentAddressDetails.PermanentPincode;
                                GlobalStore.corrPincode =
                                    cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondencePincode;
                                GlobalStore.sameAsPermanent =
                                    cacheResponse?.Data.corrsaddraspermanent !== null &&
                                        cacheResponse?.Data.corrsaddraspermanent !== undefined
                                        ? cacheResponse?.Data.corrsaddraspermanent
                                        : true;
                                clientPartialDetails_ao.isSeniorCitizen =
                                    window.sessionStorage.getItem("isSeniorCitizen") === "true"
                                        ? true
                                        : false;
                                clientPartialDetails_ao.PinCode =
                                    cacheResponse?.Data.PermanentAddressDetails.PermanentPincode;
                                clientPartialDetails_ao.corrPincode =
                                    cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondencePincode;
                                clientPartialDetails_ao.leadID = GlobalStore.leadId;
                                clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
                                clientPartialDetails_ao.pan = values.pan || values.gurdianPanNo;
                                clientPartialDetails_ao.panDetails =
                                    GlobalStore.personaldetails.panDetails;
                                clientPartialDetails_ao.token = GlobalStore.token;
                                clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
                                clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
                                clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
                                clientPartialDetails_ao.isNormalClient =
                                    GlobalStore.isNormalClient;
                                localStorageSetItem(
                                    "clientPartialDetails_ao",
                                    JSON.stringify(clientPartialDetails_ao)
                                );
                                if (skipSavePANDOB) menuOption();
                                // history.push(dashboardUrl.profile);
                                navigate(dashboardUrl.profile)
                            }
                        } else {
                            originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
                        }

                        setCacheResponse(res?.data);
                    } else {
                        originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
                        setCacheResponse(null);
                    }
                },
                {
                    uniqueID: GlobalStore?.applicationID,
                    key: `AOPDROPOFF-${GlobalStore?.applicationID}`,
                }
            );
        } else {
            originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
        }

    }

    const kraDobCheckNew = (res: any, applicationIdExists?: boolean) => {
        if (!res || res?.error) {
            // setErrCode(1227);
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({ action: "GetKraDetails", label: "ERROR || ERR108" });
            navigateTo(applicationIdExists);
        } else {
            const responseObj = res.data;

            if (responseObj?.DOB) {
                let dobValue = responseObj.DOB;

                // Check if it's in dd/mm/yyyy format
                if (/^\d{2}\/\d{2}\/\d{4}$/.test(dobValue)) {
                    const [day, month, year] = dobValue.split("/");
                    dobValue = new Date(`${year}-${month}-${day}`);
                }

                if (ageCalculator(dobValue) >= 60) {
                    window.sessionStorage.setItem("isSeniorCitizen", "true");
                }
            }

            if (responseObj?.AppErrorDesc?.includes("INVALID DOB")) {
                setIsLoading(false);

                // setErrCode('Date of Birth is not matching with the PAN');
                setErrCode(errCode ? errCode : "" + (res?.error || ""));
                setErrors({ ...errors, dob: errorMsg(errorCode.FE11) });
            } else {
                getKraDetails(responseObj, applicationIdExists);
            }
        }
    };

    const getProductCode = () => {
        let productCodeNew: string = "";
        if (
            GlobalStore?.user?.accountType !== null &&
            GlobalStore?.user?.accountType !== undefined &&
            GlobalStore?.user?.accountType !== ""
        ) {
            productCodeNew = GlobalStore?.user?.accountType;
        } else {
            const objAccType = window.sessionStorage.getItem("objAccType");
            if (
                localProductCode !== null &&
                localProductCode !== undefined &&
                localProductCode !== "" &&
                localProductCode?.length > 0
            ) {
                productCodeNew = localProductCode;
            } else {
                if (objAccType === "DMT") {
                    productCodeNew = "D";
                } else if (objAccType === "RMINV") {
                    productCodeNew = "I";
                } else {
                    productCodeNew = "TD";
                }
            }
        }

        return productCodeNew;
    };
    const getAccountCategory = () => {
        let accountCategory = null;
        if (getProductCode() == "I") {
            accountCategory = 2;
        } else {
            accountCategory = 1;
        }
        return accountCategory;
    };
    function dobMatched(
        kycobj: any,
        applicationIdExists?: boolean,
        cacheResonse?: boolean
    ) {
        const objUTM_Info = utmDurationInfoObj(startTime, "registrationdur");
        let objAccType = window.sessionStorage.getItem("objAccType") || ""; // only demat getting parameter type
        const objUtm = JSON.parse(
            window.sessionStorage.getItem("objUTM_Info") || "{}"
        );
        const modifiedBy = window.sessionStorage.getItem('empCode')
        const panDobObj = {
            leadId: GlobalStore.leadId,
            emailID: GlobalStore.user.email,
            mobileno: GlobalStore.user.mobile,
            isemployeepan: isEmployee,
            panNo: values.pan || values?.gurdianPanNo,
            dob: GlobalStore.dateofbirth,
            product: getProductCode(),
            platform: 1,
            panFName: values?.firstName,
            panMName: values?.middleName,
            panLName: values?.lastName,
            PanFSName: values.fatherName,
            SendSelfieLink: togPhoto, //((photoObj.base64==null || photoObj.base64=="") && togPhoto==false) ? true:
            diyReferralLink: localURL,
            accountCategory: getAccountCategory() !== null ? getAccountCategory() : 0,
            createdBy: objAccType === "RMINV"
                ? (objUtm?.utmsource || objUtm?.utm_source) === "PARTNER"
                    ? objUtm?.AssignedTo
                    : objUtm?.utm_campaign :
                skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
                    ? parseInt(prodObj?.createdBy)
                    : 0,
            rmAssisted: objAccType === "RMINV" ? true :
                skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
                    ? true
                    : false,
            entityType: entityType || "",
            entitySubType: entitySubType || "",
            gurdianPanNo: values?.gurdianPanNo,
            gurdianDOB: moment(values?.gurdianDOB).format("MM/DD/YYYY"),
            gurdianFName: values?.gurdianFName,
            gurdianMName: values?.gurdianMName,
            gurdianLName: values?.gurdianLName,
            accountTypeName: SUBTYPE_MAP[GlobalStore.entitySubType] || null,
            panCompFirmName: values.fullname || "",
            ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0,
            relationshipId: values?.relationshipId
        };
        ASavePanDobDetails(
            (res: any) =>
                applicationInitialized(res, kycobj, applicationIdExists, cacheResonse),
            panDobObj
        );
    }
    const isMinor = (dob: any) => {
        const today = new Date();
        const birthDate = new Date(dob); // Parse the DOB
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        // Adjust age if the current date is before the birthday in the current year
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            return age - 1 < 18;
        }

        if (age < 18) {
            return true;
        } else {
            return false;
        }
    };
    function applicationInitialized(
        res: any,
        kycobj: any,
        applicationIdExists?: boolean,
        cacheResponse?: boolean
    ) {
        if (!res || res?.error) {
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({ action: "SavePanDobDetails", label: "ERROR || ERR106" });
            setIsLoading(false);
        } else {
            if (res.data && res.data.LeadId) {
                GlobalStore.leadId = res.data.LeadId;
                GlobalStore.token = res.data.Token;
                GlobalStore.applicationID = res.data.ApplicationID;
                GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
                GlobalStore.aadharLinkedChoice =
                    values.aadharLinked === "Yes" ? true : false;
                GlobalStore.personaldetails.pan = values.pan || values.gurdianPanNo;
                //  GlobalStore.personaldetails.aadharNo = values.aadhaarNo.slice(-4);
                // Create link for capturing selfie from mobile
                let AccountObj = {
                    PanNo: values?.pan,
                    AccountCategory: getProductCode() == "I" ? 2 : 1,
                    userid: prodObj?.createdBy,
                };
                let accountObjString = JSON.stringify(AccountObj);
                const encodedPan = btoa(accountObjString);
                let stringParams = `selfie?id=${encodedPan}`;

                const selfieUrl = `${config.root}${stringParams}`;
                GlobalStore.selfieUrl = selfieUrl;
                const clientObj = {
                    clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
                    applicationId: GlobalStore.applicationID,
                };
                window.sessionStorage.setItem(
                    "clientDetails",
                    JSON.stringify(clientObj)
                );

                //extract pan
                // if (cacheResponse == true) {
                //     const clientPartialDetails_ao = JSON.parse(
                //         localStorageGetItem("clientPartialDetails_ao") || "{}"
                //     );
                //     clientPartialDetails_ao.clientPrimaryDetailId =
                //         GlobalStore.clientPrimaryDetailId;
                //     clientPartialDetails_ao.token = GlobalStore.token;
                //     clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
                //     clientPartialDetails_ao.dob = GlobalStore.dob;
                //     clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
                //     clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
                //     clientPartialDetails_ao.pan = values.pan;
                //     clientPartialDetails_ao.aadharLinkedChoice =
                //         GlobalStore.aadharLinkedChoice;
                //     clientPartialDetails_ao.leadID = GlobalStore.leadId;
                //     clientPartialDetails_ao.emailID = GlobalStore.user.email;
                //     clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
                //     clientPartialDetails_ao.panDetails =
                //         GlobalStore.personaldetails.panDetails;
                //     clientPartialDetails_ao.PANName = GlobalStore.personaldetails.PANName;
                //     clientPartialDetails_ao.isSeniorCitizen =
                //         window.sessionStorage.getItem("isSeniorCitizen") === "true"
                //             ? true
                //             : false;
                //     clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
                //     clientPartialDetails_ao.selfieUrl = GlobalStore.selfieUrl;
                //     clientPartialDetails_ao.isManual = false;
                //     clientPartialDetails_ao.aadharNo =
                //         GlobalStore.personaldetails.aadharNo;
                //     localStorageSetItem(
                //         "aadharNumber",
                //         GlobalStore.personaldetails.aadharNo
                //     );
                //     localStorageSetItem(
                //         "clientPartialDetails_ao",
                //         JSON.stringify(clientPartialDetails_ao)
                //     );
                //     // history.push(dashboardUrl.profile);
                //     navigate(dashboardUrl.profile)
                // } else {
                //     if (!willDoLater) {
                //         if (
                //             isPanLinkedToAadhar &&
                //             (getProductCode() == "I" || prodObj?.accountCategory == "2")
                //         ) {
                //             //   setShowSubmitModal(true);
                //             // if (applicationModeType !== "isKRA") {
                //             //   setApplicationModeType("isKRA");
                //             // }

                //             let filterLeftBar = leftNavBarArray;
                //             let filterNavIndexForProfiler = leftNavBarArray?.findIndex(
                //                 (filter) => filter?.navUrl == dashboardUrl.profiler
                //             );
                //             if (filterNavIndexForProfiler > 0)
                //                 filterLeftBar?.splice(filterNavIndexForProfiler, 1);
                //             let filterNavIndex = filterLeftBar?.findIndex(
                //                 (filter) => filter?.navUrl == "/plan"
                //             );
                //             if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);

                //             if (!filterLeftBar?.includes(dematNavBarObj))
                //                 filterLeftBar.push(dematNavBarObj);
                //             GlobalStore.leftNavBarState = filterLeftBar;
                //         }
                //         let panOCRval = panOCR;
                //         panOCRval.PayloadObj.applicationid = GlobalStore.applicationID;
                //         setPanOCR(panOCRval);
                //         uploadPanFile(panOCR.val, panOCR.fileName, panOCR.id, panOCR.type);
                //         // AextractPan(
                //         //   (res: any) =>
                //         //     storeOcrData(
                //         //       res,
                //         //       panOCR.val,
                //         //       panOCR.fileName,
                //         //       panOCR.id,
                //         //       panOCR.type
                //         //     ),
                //         //   panOCR.PayloadObj
                //         // );
                //     } else {
                //         if (
                //             skipUrlBoolean &&
                //             prodObj?.createdBy !== null &&
                //             prodObj?.createdBy !== undefined
                //         ) {
                //             if (isPanLinkedToAadhar !== true) {
                let filterLeftBar = leftNavBarArray;
                const allowedUrls = [
                    dashboardUrl.profile,
                    dashboardUrl.bank,
                    dashboardUrl.doc,     // Verify Personal Documents
                    dashboardUrl.plan,    // If "deemal" means plan
                ];

                filterLeftBar = leftNavBarArray.filter(item =>
                    allowedUrls.includes(item.navUrl)
                );

                // let filterNavIndexForProfiler = leftNavBarArray?.findIndex(
                //     (filter) => filter?.navUrl == dashboardUrl.profiler
                // );
                // if (filterNavIndexForProfiler > 0)
                //     filterLeftBar?.splice(filterNavIndexForProfiler, 1);
                // let filterNavIndex = filterLeftBar?.findIndex(
                //     (filter) => filter?.navUrl == "/plan"
                // );
                // if (filterNavIndex > 0)
                //     filterLeftBar?.splice(filterNavIndex, 1);
                // let filterNavIndex2 = filterLeftBar?.findIndex(
                //     (filter) => filter?.navUrl == dashboardUrl.eSign
                // );
                // if (filterNavIndex > 0)
                //     filterLeftBar?.splice(filterNavIndex2, 1);
                // let filterNavIndex3 = filterLeftBar?.findIndex(
                //     (filter) => filter?.navUrl == dashboardUrl.profiler
                // );
                // if (filterNavIndex > 0)
                //     filterLeftBar?.splice(filterNavIndex3, 1);
                // let filterNavIndex4 = filterLeftBar?.findIndex(
                //     (filter) => filter?.navUrl == dashboardUrl.ipv
                // );
                // if (filterNavIndex4 > 0)
                //     filterLeftBar?.splice(filterNavIndex4, 1);
                // if (!filterLeftBar?.includes(dematNavBarObj))
                //     filterLeftBar.push(dematNavBarObj);
                GlobalStore.setLeftNavBarState(filterLeftBar);
                // } else {
                //     //  setShowSubmitModal(true);
                //     setDobChecked(true);
                //     // if (applicationModeType !== "isKRA") {
                //     //   setApplicationModeType("isKRA");
                //     // }
                //     let filterLeftBar = leftNavBarArray;
                //     let filterNavIndex = filterLeftBar?.findIndex(
                //         (filter) => filter?.navUrl == "/plan"
                //     );
                //     if (filterNavIndex > 0)
                //         filterLeftBar?.splice(filterNavIndex, 1);
                //     let filterNavIndex2 = filterLeftBar?.findIndex(
                //         (filter) => filter?.navUrl == dashboardUrl.eSign
                //     );
                //     if (filterNavIndex > 0)
                //         filterLeftBar?.splice(filterNavIndex2, 1);
                //     let filterNavIndex3 = filterLeftBar?.findIndex(
                //         (filter) => filter?.navUrl == dashboardUrl.profiler
                //     );
                //     if (filterNavIndex > 0)
                //         filterLeftBar?.splice(filterNavIndex3, 1);
                //     let filterNavIndex4 = filterLeftBar?.findIndex(
                //         (filter) => filter?.navUrl == dashboardUrl.ipv
                //     );
                //     if (filterNavIndex4 > 0)
                //         filterLeftBar?.splice(filterNavIndex4, 1);
                //     if (!filterLeftBar?.includes(dematNavBarObj))
                //         filterLeftBar.push(dematNavBarObj);
                //     GlobalStore.leftNavBarState = filterLeftBar;
                // }
                //     }
                // }

                const clientPartialDetails_ao = {
                    clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
                    token: GlobalStore.token,
                    applicationId: GlobalStore.applicationID,
                    dob: GlobalStore.dob,
                    dateOfIncorporation: GlobalStore.dateOfIncorporation,
                    birthDate: GlobalStore.birthDate,
                    pan: values.pan || values.gurdianPanNo,
                    aadharLinkedChoice: GlobalStore.aadharLinkedChoice,
                    leadID: GlobalStore.leadId,
                    emailID: GlobalStore.user.email,
                    mobile: GlobalStore.user.mobile,
                    panDetails: GlobalStore.personaldetails.panDetails,
                    PANName: GlobalStore.personaldetails.PANName,
                    isSeniorCitizen:
                        window.sessionStorage.getItem("isSeniorCitizen") === "true"
                            ? true
                            : false,
                    isDigiLocker: GlobalStore.isDigiLocker,
                    isKRA: false,
                    isKYC: false,
                    isSeeding: GlobalStore.isSeeding,
                    selfieUrl: GlobalStore.selfieUrl,
                    isManual: false,
                    aadharNo: GlobalStore.personaldetails.aadharNo,
                    fsfullName: values?.fatherName,
                };
                localStorageSetItem(
                    "aadharNumber",
                    GlobalStore.personaldetails.aadharNo
                );
                localStorageSetItem(
                    "clientPartialDetails_ao",
                    JSON.stringify(clientPartialDetails_ao)
                );

                nextprocess(kycobj);

            } else {
                // setErrCode('120 - Error in Application initialization.');
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                setIsLoading(false);
            }
        }
        //setApplicationInitializedFlag(true);
    }

    React.useEffect(() => {
        if (applicationInitializedFlag && applicationModeType === "isDigiLocker" && (!(objAccType === 'RMINV' && !GlobalStore.isKRA))) {
            setShowSubmitModal(true);
        }
    }, [applicationInitializedFlag, applicationModeType]);

    function checkPendingUpload(res: any) {
        if (!res || res?.error) {
            // setErrCode('1221 - Error in fetching pending document upload list.');
            //   setErrCode(errorMessage.checkPendingUpload);
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR112" });
            setIsLoading(false);
        } else {
            if (res && res?.data == null) {
                let isUploadDocumentsCompleted: boolean = false;
                AGetStageCompletionStatus(
                    (res: any) => getClientStageDetails(res, isUploadDocumentsCompleted),
                    GlobalStore.applicationID
                );
            } else if (res && res.data !== null) {
                const list: Array<any> = JSON.parse(res.data).filter(
                    (item: any) =>
                        // Prev api response
                        // item.documentcategoryid !== 36 &&
                        // item.documentcategoryid !== 30 &&
                        // item.documentcategoryid !== 62

                        // Current Api response
                        item.Mandatory == true
                );
                let isUploadDocumentsCompleted: boolean = false;
                if (list.length === 0 || list[0].count === 0)
                    isUploadDocumentsCompleted = true;
                const redisReqObj = {
                    applicationId: GlobalStore.applicationID,
                    clientPrimaryDetailsId: GlobalStore.clientPrimaryDetailId,
                };
                // ARedisDigilockerDoc(
                //   (res: any) => getRedisData(res, isUploadDocumentsCompleted),
                //   redisReqObj
                // );
                AGetStageCompletionStatus(
                    (res: any) => getClientStageDetails(res, isUploadDocumentsCompleted),
                    GlobalStore.applicationID
                );
            } else {
                // setErrCode('1222 - Error in fetching pending document upload list.');
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                setIsLoading(false);
            }
        }
    }

    function getClientStageDetails(
        res: any,
        isUploadDocumentsCompleted: boolean
    ) {
        if (!res || res?.error) {
            // setErrCode('1061 - Error in fetching stage completion details.');
            // setErrCode(errorMessage.getClientStageDetails);
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({
                action: "GetStageCompletionStatus",
                label: "ERROR || ERR113",
            });
            setIsLoading(false);
        } else {
            if (res.data) {
                const responseObj = JSON.parse(res.data);
                GlobalStore.entityType = responseObj?.entitytype
                GlobalStore.entitySubType = responseObj?.entitysubtype
                //set stage api data to GlobalStore
                setStageData(responseObj);
                let cacheData = null;
                //check completeness of stages
                checkModuleCompleteness(isUploadDocumentsCompleted);
                setCheckpanaaddharflag(responseObj.checkpanaaddharflag);
                setStageBooleanFlags((stageBooleanFlags) => {
                    stageBooleanFlags.isPersonalStage =
                        responseObj?.ispersonaldetailscompleted;
                    stageBooleanFlags.isProfileStage =
                        responseObj?.isprofiledetailscompleted;
                    return stageBooleanFlags;
                });
                if (
                    skipUrlBoolean &&
                    prodObj?.createdBy !== null &&
                    prodObj?.createdBy !== undefined
                ) {
                    if (
                        !(
                            responseObj.isprofiledetailscompleted &&
                            responseObj.ispersonaldetailscompleted
                        )
                    )
                        GlobalStore.nextIncompleteStage = dashboardUrl.profile;
                } else {
                    if (responseObj.isdigilockercompleted) {
                        GlobalStore.isDigiLocker = true;
                        setApplicationModeType("isDigiLocker");
                    }
                }

                if (responseObj.iskra) {
                    GlobalStore.isKRA = true;
                    setApplicationModeType("isKRA");
                }
                if (responseObj.iskyc) GlobalStore.isKYC = true;
                //route according to stage api response
                // if (
                //     !responseObj.isdigilockercompleted &&
                //     values.aadharLinked === 'Yes' &&
                //     !GlobalStore.isDigiLocker &&
                //     !responseObj.ispersonaldetailscompleted
                // )
                //     GlobalStore.nextIncompleteStage = containerUrl.dgLocker;
                if (
                    !(
                        responseObj.isprofiledetailscompleted &&
                        responseObj.ispersonaldetailscompleted
                    )
                )
                    GlobalStore.nextIncompleteStage = dashboardUrl.profile;
                else if (!responseObj.isbankdetailscompleted) {
                    GlobalStore.nextIncompleteStage = dashboardUrl.bank;
                } else if (
                    responseObj?.accountcategory === 2 &&
                    !responseObj?.isdpcompleted
                )
                    GlobalStore.nextIncompleteStage = dashboardUrl.demat;
                else if (
                    responseObj?.accountcategory !== 2 &&
                    (!responseObj.isbrokeragesegmentcompleted ||
                        !responseObj.isbrokerageschemecompleted)
                )
                    GlobalStore.nextIncompleteStage = dashboardUrl.plan;
                else if (!isUploadDocumentsCompleted)
                    GlobalStore.nextIncompleteStage = dashboardUrl.doc;
                else if (
                    !GlobalStore.isDigiLocker &&
                    !GlobalStore.isKRA &&
                    !GlobalStore.isKYC &&
                    !responseObj.isipvarificationcompleted
                )
                    GlobalStore.nextIncompleteStage = dashboardUrl.ipv;
                else if (responseObj.isagentvisitcompleted)
                    GlobalStore.nextIncompleteStage = containerUrl.ocv;
                else if (
                    skipUrlBoolean &&
                    prodObj?.createdBy !== null &&
                    prodObj?.createdBy !== undefined &&
                    !responseObj.isesigncompleted &&
                    responseObj?.accountcategory === 2
                ) {
                    if (responseObj.bpm_pd_status === 0)
                        // history.push(statusUrl.docVerificationInProgress);
                        navigate(statusUrl.docVerificationInProgress)
                    else if (responseObj.bpm_pd_status === 1)
                        // history.push(containerUrl.poa);
                        navigate(containerUrl.poa)
                } else if (!responseObj.isesigncompleted)
                    GlobalStore.nextIncompleteStage = dashboardUrl.eSign;
                else if (responseObj.bpm_pd_status === 0)
                    // history.push(statusUrl.docVerificationInProgress);
                    navigate(statusUrl.docVerificationInProgress)
                else if (responseObj.bpm_pd_status === 1)
                    // history.push(containerUrl.poa);
                    navigate(containerUrl.poa)
                if (
                    skipUrlBoolean &&
                    prodObj?.createdBy !== null &&
                    prodObj?.createdBy !== undefined &&
                    !responseObj.isesigncompleted &&
                    responseObj?.accountcategory === 2
                ) {
                    if (responseObj.bpm_pd_status === 0)
                        // history.push(statusUrl.docVerificationInProgress);
                        navigate(statusUrl.docVerificationInProgress)
                } else {
                    savePanDob(true);
                }
            } else {
                // setErrCode('1062 - Error in fetching stage completion details.');
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                setIsLoading(false);
            }
        }
    }

    function getKraDetails(res: any, applicationIdExists?: boolean) {
        if (!res || res?.error) {
            if (errCode?.includes(res?.error)) {
                setErrCode(errCode);
            } else {
                setErrCode(errCode + res?.error);
            }
            gtmService({ action: "GetKraDetails", label: "ERROR || ERR108-1" });
            navigateTo(applicationIdExists);
        } else {
            const responseObj = res.data ? res.data : res;
            if (!responseObj.AppStatus || responseObj.AppStatus !== "07") {
                setIsLoading(false)
                setErrCode("Unable to fetch KRA details. Please try again later.");
                return
            }
            if (responseObj && responseObj.AppStatus === "07") {
                GlobalStore.isKRA = true;
                if (applicationModeType !== "isKRA") {
                    setApplicationModeType("isKRA");
                }
                const clientPartialDetails_ao = JSON.parse(
                    localStorageGetItem("clientPartialDetails_ao") || "{}"
                );

                GlobalStore.KRA_email = responseObj.KraEmail
                    ? responseObj.KraEmail
                    : "";
                GlobalStore.KRA_mobile = responseObj.KraMobile
                    ? responseObj.KraMobile
                    : "";
                GlobalStore.KRA_mode = responseObj.kra_mode ? responseObj.kra_mode : 0;
                if (getAccountCategory() == 2) {
                    if (
                        skipUrlBoolean &&
                        prodObj?.createdBy !== null &&
                        prodObj?.createdBy !== undefined
                    ) {
                    } else {
                        let filterLeftBar = [...leftNavBarArray];
                        let filterNavIndex1 = filterLeftBar?.findIndex(
                            (filter) => filter?.navUrl == dashboardUrl.eSign
                        );
                        if (filterNavIndex1 > 0) filterLeftBar?.splice(filterNavIndex1, 1);
                        if (!hasNavBarEntry(filterLeftBar, authenticateNavBarObj.navUrl))
                            filterLeftBar.push(authenticateNavBarObj);
                        // GlobalStore.leftNavBarState = filterLeftBar;
                    }
                }

                // if (!GlobalStore.isKYC) {
                const resultObj = responseObj;
                GlobalStore.kraInfoObject.addressLine1 = `${resultObj.AppPerAdd1} ${resultObj.AppPerAdd2 || ""
                    } ${resultObj.AppPerAdd3 || ""}`;
                GlobalStore.kraInfoObject.addressLine1 =
                    GlobalStore.kraInfoObject.addressLine1; //.replace(/[^a-zA-Z0-9 ]/g, " ")

                GlobalStore.kraInfoObject.corrAddress = `${resultObj.AppCorAdd1} ${resultObj.AppCorAdd2 || ""
                    } ${resultObj.AppCorAdd3 || ""}`;
                GlobalStore.kraInfoObject.corrAddress =
                    GlobalStore.kraInfoObject.corrAddress; //.replace(/[^a-zA-Z0-9 ]/g, " ")
                GlobalStore.kraInfoObject.pincode = resultObj.AppPerPincd;
                GlobalStore.kraInfoObject.corrPincode = resultObj.AppCorPincd;
                GlobalStore.personaldetails.fsfullName = resultObj.FatherName
                    ? resultObj.FatherName
                    : GlobalStore.personaldetails.fsfullName;
                clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
                clientPartialDetails_ao.gender = responseObj?.Gender;
                GlobalStore.personaldetails.gender = responseObj?.Gender;
                clientPartialDetails_ao.addressLine1 =
                    GlobalStore.kraInfoObject.addressLine1;
                clientPartialDetails_ao.PinCode = GlobalStore.kraInfoObject.pincode;
                clientPartialDetails_ao.corrAddress =
                    GlobalStore.kraInfoObject.corrAddress;
                clientPartialDetails_ao.corrPincode =
                    GlobalStore.kraInfoObject.corrPincode;
                clientPartialDetails_ao.fsfullName =
                    GlobalStore.personaldetails.fsfullName;
                clientPartialDetails_ao.sameAsPermanent =
                    GlobalStore.kraInfoObject.addressLine1 ==
                        GlobalStore.kraInfoObject.corrAddress
                        ? true
                        : false;
                // } else {
                //     clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
                // }

                //getKraDocumentUpload(responseObj);
                localStorageSetItem(
                    "clientPartialDetails_ao",
                    JSON.stringify(clientPartialDetails_ao)
                );
                registerCleverTapEventAfterProceed();
                gtmService({ action: "PAN_DOB", label: "Step_Complete" });
                // if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
                setShowSubmitModal(true);
                // }
                if (
                    skipUrlBoolean &&
                    prodObj?.createdBy !== null &&
                    prodObj?.createdBy !== undefined
                ) {
                    setDocumentInfo({
                        totalDocs: [],
                        totalDocsCount: 0,
                        uploadedDocsCount: 0,
                    });
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                } //  if (applicationIdExists) history.push(GlobalStore.nextIncompleteStage);
                // else {
                //   // history.push(dashboardUrl.profile);
                //   // setIsLoading(false);
                //   setShowSubmitModal(true);
                // }
            }
        }
    }

    const checkPanValidationMsgs = (response: any) => {
        let result = "";
        Object.keys(panValidationKeyList).forEach((x) => {
            if (response[x] === "N") {
                result = result + "\n" + response[panValidationKeyList[x]];
            }
        });
        return result;
    };

    const panValidationCallback = (res: any, callBackFunction: Function) => {
        if (!res || res?.error) {
            if (panInvalidMsg?.includes(res?.error)) {
                setPanInvalidMsg(panInvalidMsg);
            } else {
                setPanInvalidMsg(panInvalidMsg + res?.error);
            }
            setIsLoading(false);
        } else {
            /*
              new api added for a pan api check
            */
            if (res && res.data) {
                panValidationResp = res.data;
                if (
                    res &&
                    res.data &&
                    (res.data?.Dob === "N" ||
                        res.data?.Name === "N" ||
                        res.data?.PanStatus === "N" ||
                        res.data?.SeedingStatus === "N")
                ) {
                    setErrorFoundInPanValidation(false);
                    setPanInvalidMsg(checkPanValidationMsgs(res.data));
                }
                if (res?.data?.SeedingStatus === "Y") {
                    isPanLinkedToAadhar = true;
                } else {
                    isPanLinkedToAadhar = false;
                }
                if (
                    (res && res.data && res.data?.Dob === "N") ||
                    res.data?.Name === "N" ||
                    res.data?.PanStatus === "N" ||
                    res.data?.SeedingStatus === "N"
                ) {
                    setIsLoading(false);
                } else {
                    setErrorFoundInPanValidation(true);
                    if (
                        values.pan === extractPanResponse?.id_number &&
                        moment(values.dob).format("YYYY-MM-DD") ===
                        extractPanResponse?.date_of_birth
                    ) {
                        setDobChecked(true);
                    } else {
                        setDobChecked(false);
                    }

                    validatePANNew(
                        res?.data?.SeedingStatus,
                        res?.data?.SeedingStatusMsg,
                        res?.data?.PanStatus
                    );
                }
            }
        }
    };
    const panValidation = (
        panObject: {
            panNo: string;
            name: string;
            dob: string;
            source: string;
        },
        callBackFunction: Function
    ) => {
        APanVerification((res: any) => {
            panValidationCallback(res, callBackFunction);
        }, panObject);
    };
    function navigateTo(applicationIdExists: boolean | undefined, reqObj?: any) {
        registerCleverTapEventAfterProceed();
        gtmService({ action: "PAN_DOB", label: "Step_Complete" });
        const clientPartialDetails_ao = JSON.parse(
            localStorageGetItem("clientPartialDetails_ao") || "{}"
        );
        if (showSubmitModal) {
            if (
                !clientPartialDetails_ao.ckycNo ||
                clientPartialDetails_ao.ckycNo === "" ||
                !clientPartialDetails_ao.isKRA
            ) {
                if (
                    skipUrlBoolean &&
                    prodObj?.createdBy !== null &&
                    prodObj?.createdBy != undefined
                ) {
                    // history.push(dashboardUrl.profile);
                    navigate(dashboardUrl.profile)
                } else {
                    // history.push(containerUrl.dgLocker);
                    navigate(containerUrl.dgLocker)
                }
            } else if (applicationIdExists) {
                // history.push(GlobalStore.nextIncompleteStage);
                navigate(GlobalStore.nextIncompleteStage)
            }
            // else if (values.aadharLinked !== 'No') history.push(containerUrl.dgLocker);
            else {
                if (!errCode && errCode.length === 0)
                    navigate(dashboardUrl.profile)
            }
        }
        if (
            (skipUrlBoolean &&
                prodObj?.createdBy !== null &&
                prodObj?.createdBy != undefined &&
                applicationIdExists) || ((objAccType === 'RMINV' && !GlobalStore.isKRA))
        ) {
            navigate(GlobalStore.nextIncompleteStage)
        }
        if (
            reqObj !== null &&
            reqObj !== undefined &&
            reqObj?.skipUrlBoolean &&
            reqObj?.rmid !== null &&
            reqObj?.rmid != undefined &&
            applicationIdExists
        ) {
            // history.push(GlobalStore.nextIncompleteStage);
            navigate(GlobalStore.nextIncompleteStage)
        }
        // if (!showSubmitModal) {
        //     if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
        setShowSubmitModal(true);
        // }
        setIsLoading(false);
        // }
    }

    // This function reads the browsed file and returns the base64 string and other details
    function onPanDocUploadComplete(
        val: any,
        fileName: string,
        id: string,
        type: string
    ) {
        setPanFileUploadedLoader(true);
        setIsLoading(true);
        panObj.imgUrl = "";
        panObj.documentId = 1;
        panObj.documentCategoryId = "2";
        panObj.uploadPer = 100;
        setPanObj(panObj);
        setErrCode("");
        setErrorFoundInPanValidation(false);
        // pan image picked, ocr extraction starting
        const panOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: val!.split(",")[1],
            documentcategory: "PAN Card",
            documentid: panObj.documentId,
            source: DIY,
        };

        setPanOCR({
            PayloadObj: panOCR,
            val: val,
            fileName: fileName,
            id: id,
            type: type,
        });

        AextractPanNew((res: any) => {
            if (!res || res?.error) {
                setIsLoading(false);
                // setErrCode('Invalid Image');
                // setErrCode(errorMessage.imgNotMatchWithPan);
                if (errCode?.includes(res?.error)) {
                    setErrCode(errCode);
                } else {
                    setErrCode(errCode + res?.error);
                }
                setPanFileUploaded(true);
                setPanFileUploadedLoader(false);
                // alert('Pan Card number entered and the uploaded image do not match. Please upload correct PAN');
                mixpanelService({
                    event: mixpanelEvents.ERROR_TRIGGERED,
                    screen_name: getScreenName(window.location.pathname),
                    error_object: res?.error,
                });
            } else {
                if (res?.data?.error && res?.data?.error !== "INVALID_PDF") {
                    setErrCode(errCode + res?.data?.error);
                    setPanFileUploaded(true);
                    setPanFileUploadedLoader(false);
                    mixpanelService({
                        event: mixpanelEvents.ERROR_TRIGGERED,
                        screen_name: getScreenName(window.location.pathname),
                        error_object: res?.data?.error,
                    });
                } else {
                    if (res && res?.data?.result) {
                        setExtractPanResponse(res?.data?.result?.extraction_output);
                        if (
                            res?.data?.result?.extraction_output?.id_number === "" ||
                            res?.data?.result?.extraction_output?.id_number === null ||
                            res?.data?.result?.extraction_output?.id_number === undefined
                        ) {
                            setInvalidPanFileUploadedMsg(
                                "Oops!! You seem to have uploaded the wrong document. Please upload Pan Card!!"
                            );
                            setPanFileUploaded(false);
                            setPanFileUploadedLoader(false);
                            mixpanelService({
                                event: mixpanelEvents.ERROR_TRIGGERED,
                                screen_name: getScreenName(window.location.pathname),
                                error_object: "wrong document uploaded, expected PAN card",
                            });
                        } else {
                            setInvalidPanFileUploadedMsg("");
                        }
                        setValues((values) => {
                            values.pan = res?.data?.result?.extraction_output?.id_number;
                            values.dob = new Date(
                                res?.data?.result?.extraction_output?.date_of_birth
                            );
                            if (res?.data?.result?.extraction_output?.name_on_card !== null) {
                                let fullName =
                                    res?.data?.result?.extraction_output?.name_on_card?.split(
                                        " "
                                    );
                                values.firstName =
                                    fullName?.length > 0 ? fullName[0] ?? "" : "";
                                values.lastName =
                                    fullName?.length > 0
                                        ? fullName[fullName?.length - 1] ?? ""
                                        : "";
                                fullName.splice(0, 1);
                                fullName.splice(fullName?.length - 1);
                                values.middleName = fullName.join(" ");
                                values.fatherName =
                                    res?.data?.result?.extraction_output?.fathers_name;
                            }

                            return values;
                        });

                        GlobalStore.personaldetails.fsfullName =
                            res?.data?.result?.extraction_output?.fathers_name;
                        const clientPartialDetails_ao = JSON.parse(
                            localStorageGetItem("clientPartialDetails_ao") || "{}"
                        );
                        clientPartialDetails_ao.fsfullName =
                            GlobalStore.personaldetails.fsfullName;
                        localStorageSetItem(
                            "clientPartialDetails_ao",
                            JSON.stringify(clientPartialDetails_ao)
                        );
                        setPanFileUploadedLoader(false);
                        if (
                            val !== null &&
                            val !== undefined &&
                            fileName?.length > 0 &&
                            id?.length > 0
                        ) {
                            setPanFileUploaded(true);
                        } else {
                            setPanFileUploaded(false);
                        }
                    } else {
                        setPanFileUploaded(true);
                        setPanFileUploadedLoader(false);
                    }
                }
            }
        }, panOCR);
        setIsLoading(false);
    }

    const handleRemove = () => {
        setPanFileUploaded(false);
        setPanFileUploadedLoader(false);
        setPanInvalidMsg("");
        setInvalidPanFileUploadedMsg("");
        setPanOCR(null);
        setErrors({
            pan: undefined,
            dob: undefined,
            aadharLinked: undefined,
            aadhaarNo: undefined,
            firstName: undefined,
            middleName: undefined,
            lastName: undefined,
        });
    };

    React.useEffect(() => {
        if (submitFlag && errCode == "") {
            handleSubmit();
        }
    }, [submitFlag, errCode]);

    function nextprocess(kycobj: any) {
        //  updateUtmInfo(() => {});

        if (false) {
            //togPhoto
            const smsBody = {
                mobNo: GlobalStore.user.mobile,
                // selfieLinkText: `Give a Smile and complete your Selfie process for Online Account Opening, click here ${selfieUrl} to complete the process. Regards, Nuvama`,
                //selfieLinkText: selfieUrl,
                selfieLinkText: GlobalStore.selfieUrl,
            };
            ASendSms((res: any) => {
                if (!res || res?.error) {
                    setErrCode(errCode + res?.error);
                } else {
                    if (res && res.data) {
                    }
                }
            }, smsBody);
        }
        if (
            isPanLinkedToAadhar !== null &&
            isPanLinkedToAadhar !== undefined &&
            isPanLinkedToAadhar == true
        ) {
            setIsLoading(true);
            const reqObj = {
                dbo: `${moment(values.gurdianDOB).format("DD/MM/YYYY")}`,
                panno: values.gurdianPanNo,
                applicationId: GlobalStore.applicationID,
                clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
                // documentInfo: saveDetails,
                leadId: GlobalStore.leadId,
                CreatedBy:
                    skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
                        ? parseInt(prodObj?.createdBy)
                        : 0,
            };
            AGetKraDetails(
                (res: any) =>
                    kraDobCheckNew(
                        res,
                        GlobalStore?.applicationID !== null &&
                            GlobalStore?.applicationID !== undefined
                            ? true
                            : false
                    ),
                reqObj
            );
        } else {
            setIsNormalClient(true);
            GlobalStore.isNormalClient = true;
            const clientPartialDetails_ao = JSON.parse(
                localStorageGetItem("clientPartialDetails_ao") || "{}"
            );
            clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
            localStorageSetItem(
                "clientPartialDetails_ao",
                JSON.stringify(clientPartialDetails_ao)
            );
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (objAccType == "RMINV") {
            setSkipUrlBoolean(true)
            setPanFileUploadedLoader(false);
            setPanFileUploaded(true);
            setWillDoLater(true);
        }
    }, [objAccType])

    const checkStatus = () => {
        // history.push(statusUrl.statusHome)
        navigate(statusUrl.statusHome)
    };

    const handleRelationshipSelect = (item: any) => {
        setValues(prev => ({
            ...prev,
            relationshipId: item.value
        }));
    };

    return (
        <>
            {/* <Backdrop isCloseIcon isShow={showDigiRedirection} onClose={() => setShowDigiRedirection(false)}>
                <CheckDigilockerPopup onClose={setShowDigiRedirection} />
            </Backdrop> */}

            {/* need to change Indian to joint */}
            {entitySubType == "Joint" ? <PANInfoJoint /> :
                <div className={"pan" + (isLoading ? " op05" : "")}>
                    <div className="banner">
                        <img className="bannerImg" src={regbanner} alt="" aria-hidden="true" />
                    </div>
                    <h1 className="panHeading">Let’s Get Started</h1>
                    <div className="panInfo">
                        <span>
                            Please provide your PAN Card details below to proceed
                        </span>
                    </div>
                    {!skipUrlBoolean && (
                        <div className="panInfo">
                            <span>
                                Please upload a PAN Card to verify your details on Pan Card.
                            </span>
                        </div>
                    )}
                    {entityType == "NONINDIVIDUAL" &&
                        <div className="nonIndParent">
                            <div className="nonInd">
                                NONINDIVIDUAL Investment Account
                            </div>
                        </div>
                    }
                    <div className="panForm">
                        <form>
                            <fieldset disabled={isLoading}>
                                <legend className="sr-only">PAN verification</legend>
                                {!skipUrlBoolean && (
                                    <div className="row">
                                        <div className={isLoading ? "not-allowed" : ""}>
                                            <div className="uploadLayout">
                                                <div className="mrt60 row">
                                                    <p className="photoSubHeading mrt10">
                                                        Upload PAN Card
                                                    </p>
                                                    <div className="mrt20">
                                                        <DocumentBrowse
                                                            id="panCard"
                                                            docObj={panObj}
                                                            previewImageexternalClassName={"maxSizewithAnother"}
                                                            onDocUploadComplete={onPanDocUploadComplete}
                                                            isRemove={handleRemove}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {panFileUploadedLoader && (
                                    <div className="row">
                                        <Loader size={20} />
                                    </div>
                                )}
                                {invalidPanFieldUploadedMsg != "" && (
                                    <div className="errMsgBlck">
                                        <ErrMsg>
                                            <span>{invalidPanFieldUploadedMsg}</span>
                                        </ErrMsg>
                                    </div>
                                )}
                                {panFileUploaded &&
                                    !panFileUploadedLoader &&
                                    invalidPanFieldUploadedMsg == "" && (
                                        <>
                                            <fieldset disabled={errorFoundInPanValidation}>
                                                <legend className="sr-only">PAN verification</legend>
                                                <div className="row">
                                                    <span className="inptLblTitle">Details of minor</span>
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="firstName">First Name</label>
                                                    <InputField
                                                        id="firstName"
                                                        name="firstName"
                                                        className="panInput"
                                                        disabled={
                                                            prodObj?.createdBy !== null &&
                                                            prodObj?.createdBy !== undefined &&
                                                            prodObj?.createdBy !== 0 &&
                                                            values?.firstName !== null &&
                                                            values?.firstName !== undefined &&
                                                            values?.firstName !== ""
                                                        }
                                                        defaultValue={values?.firstName} //To be removed
                                                        onChange={(value) => onChange("firstName", value)}
                                                        required={true}
                                                        onBlur={(error: any, event) => {
                                                            if (error.required) {
                                                                setErrors({
                                                                    ...errors,
                                                                    firstName: errorMsg(errorCode.FE57),
                                                                });
                                                            } else if (
                                                                !!values?.firstName &&
                                                                (values.firstName as string).slice(-1) == " "
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    firstName: errorMsg(errorCode.FE55),
                                                                });
                                                            } else if (
                                                                !!event?.target?.value &&
                                                                event?.target?.value?.length > 0 &&
                                                                !event?.target?.value?.replace(/\s/g, "").length
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    // firstname: error.required ? 'This field is required' : '',
                                                                    firstName: errorMsg(errorCode.FE55),
                                                                });
                                                            }
                                                        }}
                                                        type="text"
                                                        placeholder="Eg. Pranav"
                                                        //  pattern={pan}
                                                        errorText={errors.firstName}
                                                        maxLength={20}
                                                    // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="middleName">Middle Name</label>
                                                    <InputField
                                                        id="middleName"
                                                        name="middleName"
                                                        className="panInput"
                                                        defaultValue={values?.middleName}
                                                        disabled={
                                                            prodObj?.createdBy !== null &&
                                                            prodObj?.createdBy !== undefined &&
                                                            prodObj?.createdBy !== 0 &&
                                                            values?.middleName !== null &&
                                                            values?.middleName !== undefined &&
                                                            values?.middleName !== ""
                                                        }
                                                        // defaultValue="CWLPA4946C" //To be removed
                                                        onChange={(value) => onChange("middleName", value)}
                                                        onBlur={(error: any, event) => {
                                                            if (
                                                                !!values?.middleName &&
                                                                (values.middleName as string).slice(-1) == " "
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    middleName: errorMsg(errorCode.FE55),
                                                                });
                                                            } else if (
                                                                !!event?.target?.value &&
                                                                event?.target?.value?.length > 0 &&
                                                                !event?.target?.value?.replace(/\s/g, "").length
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    // firstname: error.required ? 'This field is required' : '',
                                                                    middleName: errorMsg(errorCode.FE55),
                                                                });
                                                            }
                                                        }}
                                                        type="text"
                                                        placeholder="Eg. Prashant"
                                                        //  pattern={pan}
                                                        errorText={errors.middleName}
                                                        maxLength={20}
                                                    // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="lastName">Last Name</label>
                                                    <InputField
                                                        id="lastName"
                                                        name="lastName"
                                                        className="panInput"
                                                        defaultValue={values?.lastName}
                                                        // defaultValue="CWLPA4946C" //To be removed
                                                        disabled={
                                                            prodObj?.createdBy !== null &&
                                                            prodObj?.createdBy !== undefined &&
                                                            prodObj?.createdBy !== 0 &&
                                                            values?.lastName !== null &&
                                                            values?.lastName !== undefined &&
                                                            values?.lastName !== ""
                                                        }
                                                        onChange={(value) => onChange("lastName", value)}
                                                        onBlur={(error, event) => {
                                                            if (
                                                                !!values?.lastName &&
                                                                (values.lastName as string).slice(-1) == " "
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    lastName: errorMsg(errorCode.FE55),
                                                                });
                                                            } else if (
                                                                !!event?.target?.value &&
                                                                event?.target?.value?.length > 0 &&
                                                                !event?.target?.value?.replace(/\s/g, "").length
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    // firstname: error.required ? 'This field is required' : '',
                                                                    lastName: errorMsg(errorCode.FE55),
                                                                });
                                                            }
                                                        }}
                                                        type="text"
                                                        placeholder="Eg. Joshi"
                                                        //  pattern={pan}
                                                        errorText={errors.lastName}
                                                        maxLength={40}
                                                    // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                                                    />
                                                </div>
                                                {/* DOB start */}
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="dob">Date of Birth</label>
                                                    <Calender
                                                        id="dob"
                                                        name="dob"
                                                        onDateSelect={(val) => onChange("dob", val)}
                                                        defaultDate={values?.dob ? values.dob : undefined}
                                                        placeholderText={"Select Date of Birth"}
                                                        maxDate={new Date(new Date().setFullYear(new Date().getFullYear()))}
                                                        minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
                                                        disable={isLoading || errorFoundInPanValidation || getCheckedDobCondition()}
                                                        isError={errors.dob ? true : false}
                                                        errorText={errors.dob}
                                                    />
                                                </div>

                                                {/* Radio: Does minor have PAN */}
                                                <fieldset className="row">
                                                    <legend className="inptLbl">Does the Minor have a PAN?</legend>

                                                    <div className="radioRow">
                                                        <label className="radioOption">
                                                            <input
                                                                type="radio"
                                                                id="minorPan-yes"
                                                                name="minorPan"
                                                                checked={values?.minorPan === "yes"}
                                                                onChange={() => onChange("minorPan", "yes")}
                                                                disabled={prodObj?.uccCode}
                                                            />
                                                            Yes
                                                        </label>

                                                        <label className="radioOption">
                                                            <input
                                                                type="radio"
                                                                id="minorPan-no"
                                                                name="minorPan"
                                                                checked={values?.minorPan === "no"}
                                                                onChange={() => onChange("minorPan", "no")}
                                                                disabled={prodObj?.uccCode}
                                                            />
                                                            No
                                                        </label>
                                                    </div>
                                                </fieldset>


                                                {/* PAN Field - Show only if minorPan === "yes" */}
                                                {values?.minorPan === "yes" && (
                                                    <div className="row">
                                                        <label className="inptLbl" htmlFor="pan">Enter PAN</label>
                                                        <InputField
                                                            id="pan"
                                                            name="pan"
                                                            className="panInput"
                                                            defaultValue={values?.pan}
                                                            onChange={(value) => {
                                                                setPanInvalidMsg("");
                                                                onChange("pan", value.toUpperCase());
                                                            }}
                                                            onBlur={(error) => onBlurPan(error)}
                                                            type="text"
                                                            placeholder="Eg. ABCDE1234F"
                                                            pattern={pan}
                                                            errorText={errors.pan}
                                                            maxLength={10}
                                                            disabled={prodObj?.uccCode}
                                                        // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                                                        />
                                                    </div>
                                                )}


                                                {/* Guardian section starts */}
                                                <div className="row">
                                                    <span className="inptLblTitle">Guardian Information</span>
                                                </div>
                                                <div className="row">
                                                    <p className="inptLblNote">As this is a minor account, the Guardian will be the authorised person responsible for all transactions and account operations</p>
                                                </div>

                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="gurdianFName">First Name</label>
                                                    <InputField
                                                        id="gurdianFName"
                                                        name="gurdianFName"
                                                        className="panInput"
                                                        disabled={false}
                                                        defaultValue={values?.gurdianFName} //To be removed
                                                        onChange={(value) => onChange("gurdianFName", value)}
                                                        required={true}
                                                        onBlur={(error: any, event) => {
                                                            if (error.required) {
                                                                setErrors({
                                                                    ...errors,
                                                                    gurdianFName: errorMsg(errorCode.FE57),
                                                                });
                                                            } else if (
                                                                !!values?.gurdianFName &&
                                                                (values.gurdianFName as string).slice(-1) == " "
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    gurdianFName: errorMsg(errorCode.FE55),
                                                                });
                                                            } else if (
                                                                !!event?.target?.value &&
                                                                event?.target?.value?.length > 0 &&
                                                                !event?.target?.value?.replace(/\s/g, "").length
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    // gurdianFName: error.required ? 'This field is required' : '',
                                                                    gurdianFName: errorMsg(errorCode.FE55),
                                                                });
                                                            }
                                                        }}
                                                        type="text"
                                                        placeholder="Eg. Pranav"
                                                        //  pattern={pan}
                                                        errorText={errors.gurdianFName}
                                                        maxLength={20}
                                                    // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="gurdianMName">Middle Name</label>
                                                    <InputField
                                                        id="gurdianMName"
                                                        name="gurdianMName"
                                                        className="panInput"
                                                        disabled={false}
                                                        defaultValue={values?.gurdianMName} //To be removed
                                                        onChange={(value) => onChange("gurdianMName", value)}
                                                        // required={true}
                                                        onBlur={(error: any, event) => {
                                                            if (
                                                                !!values?.gurdianMName &&
                                                                (values.gurdianMName as string).slice(-1) == " "
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    gurdianMName: errorMsg(errorCode.FE55),
                                                                });
                                                            } else if (
                                                                !!event?.target?.value &&
                                                                event?.target?.value?.length > 0 &&
                                                                !event?.target?.value?.replace(/\s/g, "").length
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    // gurdianMName: error.required ? 'This field is required' : '',
                                                                    gurdianMName: errorMsg(errorCode.FE55),
                                                                });
                                                            }
                                                        }}
                                                        type="text"
                                                        placeholder="Eg. Pranav"
                                                        //  pattern={pan}
                                                        errorText={errors.gurdianMName}
                                                        maxLength={20}
                                                    // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="gurdianLName">Last Name</label>
                                                    <InputField
                                                        id="gurdianLName"
                                                        name="gurdianLName"
                                                        className="panInput"
                                                        disabled={false}
                                                        defaultValue={values?.gurdianLName} //To be removed
                                                        onChange={(value) => onChange("gurdianLName", value)}
                                                        // required={true}
                                                        onBlur={(error: any, event) => {
                                                            if (error.required) {
                                                                setErrors({
                                                                    ...errors,
                                                                    gurdianLName: errorMsg(errorCode.FE57),
                                                                });
                                                            } else if (
                                                                !!values?.gurdianLName &&
                                                                (values.gurdianLName as string).slice(-1) == " "
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    gurdianLName: errorMsg(errorCode.FE55),
                                                                });
                                                            } else if (
                                                                !!event?.target?.value &&
                                                                event?.target?.value?.length > 0 &&
                                                                !event?.target?.value?.replace(/\s/g, "").length
                                                            ) {
                                                                setErrors({
                                                                    ...errors,
                                                                    // gurdianLName: error.required ? 'This field is required' : '',
                                                                    gurdianLName: errorMsg(errorCode.FE55),
                                                                });
                                                            }
                                                        }}
                                                        type="text"
                                                        placeholder="Eg. Pranav"
                                                        //  pattern={pan}
                                                        errorText={errors.gurdianLName}
                                                        maxLength={20}
                                                    // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="gurdianDOB">Date of Birth</label>
                                                    <Calender
                                                        id="gurdianDOB"
                                                        name="gurdianDOB"
                                                        // defaultDate={new Date('December 24, 1996 00:00:00')} //To be removed
                                                        onDateSelect={(val) => onChange("gurdianDOB", val)}
                                                        defaultDate={values?.gurdianDOB ? values.gurdianDOB : undefined}
                                                        placeholderText={"Select Date of Birth"}
                                                        maxDate={
                                                            new Date(
                                                                new Date().setFullYear(
                                                                    new Date().getFullYear() - 18
                                                                )
                                                            )
                                                        }
                                                        minDate={
                                                            new Date(
                                                                new Date().setFullYear(
                                                                    new Date().getFullYear() - 100
                                                                )
                                                            )
                                                        }
                                                        onBlur={() => { }}
                                                        disable={
                                                            isLoading ||
                                                            errorFoundInPanValidation ||
                                                            getCheckedDobCondition()
                                                        }
                                                        isError={errors.dob ? true : false}
                                                        errorText={errors.dob}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="gurdianPanNo">Enter PAN </label>
                                                    <InputField
                                                        id="gurdianPanNo"
                                                        name="gurdianPanNo"
                                                        className="panInput"
                                                        disabled={prodObj?.guardianPan && prodObj?.uccCode}
                                                        defaultValue={values?.gurdianPanNo}
                                                        // defaultValue="CWLPA4946C" //To be removed
                                                        onChange={(value) => {
                                                            setPanInvalidMsg("");
                                                            onChange("gurdianPanNo", value.toUpperCase());
                                                        }}
                                                        onBlur={(error) => onBlurPanMinor(error)}
                                                        type="text"
                                                        placeholder="Eg. ABCDE1234F"
                                                        pattern={pan}
                                                        errorText={errors.gurdianPanNo}
                                                        maxLength={10}
                                                    // suffix={
                                                    //   validPan ? <i className="edel-icon-tick" /> : <></>
                                                    // }
                                                    />
                                                </div>
                                                <div className="row">
                                                    <label className="inptLbl" htmlFor="guardianRelationship">Guardian Relationship </label>
                                                    <DropdownSearch
                                                        id="guardianRelationship"
                                                        name="guardianRelationship"
                                                        searchLength={0}
                                                        options={relationShipList}
                                                        searchKey="display"
                                                        placeholder="Select Relationship"
                                                        isDownArrow={true}
                                                        // defaultValue={relationShipList[0].display}
                                                        onOptionSelect={handleRelationshipSelect}
                                                    />
                                                </div>
                                                {/* DOB end */}
                                            </fieldset>


                                            {showSubmitModal && (
                                                <div
                                                    style={{
                                                        justifyContent: "center",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        height: "160px",
                                                    }}
                                                >
                                                    <Backdrop
                                                        width="width50"
                                                        isShow={modalDisplayText}
                                                        isCloseIcon={false}
                                                        ariaLabelledBy="pan-minor-modal-title"
                                                    >
                                                        <h2 id="pan-minor-modal-title">Please Note!</h2>
                                                        <div className="explainInfo">
                                                            {modalDisplayText ? (
                                                                <div
                                                                    className="modaltext-Div"
                                                                    style={{ fontSize: "20px" }}
                                                                >
                                                                    {modalDisplayText}
                                                                </div>
                                                            ) : (
                                                                "Loading..."
                                                            )}
                                                        </div>
                                                        <div className="mrt16  mrb16 sunBtn">
                                                            <button
                                                                className={`panpage-modalSubmit ${documentsInfo.totalDocsCount !==
                                                                    documentsInfo.uploadedDocsCount
                                                                    ? "disable"
                                                                    : ""
                                                                    }`}
                                                                onClick={() => {
                                                                    try {
                                                                        const screen_name = getScreenName(window.location.pathname);
                                                                        if (screen_name) {
                                                                            mixpanelService({
                                                                                event: mixpanelEvents.CTA_CLICKED,
                                                                                screen_name,
                                                                                text: "OK, Proceed",
                                                                                cta_type: "sticky",
                                                                                cta_class: "primary",
                                                                                cta_service: "AOJ",
                                                                            });
                                                                        }
                                                                    } catch (e) {
                                                                        console.error("mixpanel cta_clicked failed", e);
                                                                    }
                                                                    navigate(dashboardUrl.profile);
                                                                }}
                                                                type="submit"
                                                                disabled={
                                                                    documentsInfo.totalDocsCount !==
                                                                    documentsInfo.uploadedDocsCount
                                                                }
                                                            >
                                                                {documentsInfo.totalDocsCount !==
                                                                    documentsInfo.uploadedDocsCount
                                                                    ? "Please Wait"
                                                                    : "OK, Proceed"}
                                                            </button>
                                                        </div>
                                                    </Backdrop>
                                                </div>
                                            )}
                                            {entityType !== "NONINDIVIDUAL" &&
                                                <div className="termList mrt41">
                                                    <Checkbox
                                                        checked={consent}
                                                        name="termone"
                                                        onChange={() => { }}
                                                    />
                                                    <span className="mrl13 linkLabel">
                                                        I authorize Nuvama to pull KYC records of guardian through KRA
                                                    </span>
                                                </div>
                                            }

                                            {utmObj &&
                                                Object.keys(utmObj).length > 0 &&
                                                utmObj.utm_source &&
                                                utmObj.utm_content &&
                                                utmObj.utm_campaign && (
                                                    <div className="termList mrt41">
                                                        <span className="linkLabel assisted-label">
                                                            You are being assisted
                                                        </span>
                                                    </div>
                                                )}

                                            {/* Error Msg Start*/}
                                            {errCode && (
                                                <div className="errMsgBlck">
                                                    <ErrMsg>
                                                        {typeof errCode === "number" ? (
                                                            <>
                                                                <span>We are facing some technical issue.</span>
                                                                <span>
                                                                    Please try after sometime (error code:{errCode})
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span>{errCode}</span>
                                                        )}
                                                    </ErrMsg>
                                                </div>
                                            )}
                                            {/* Error Msg End*/}
                                            {/* Pan Matching  Error Msg Start */}
                                            {panInvalidMsg !== "" && panInvalidMsg?.length > 0 && (
                                                <div className="errMsgBlck">
                                                    <ErrMsg>
                                                        <span>{panInvalidMsg}</span>
                                                    </ErrMsg>
                                                </div>
                                            )}
                                            {/* Pan Matching  Error Msg End */}
                                            <div className="row">
                                                <Button
                                                    onClick={handleSubmit} //isNormalClient ? handleContinue :
                                                    btnName={isNormalClient ? "Continue" : "Proceed"}
                                                    // onClick={handleSubmit}
                                                    // btnName={"Proceed"}
                                                    disabled={
                                                        !values?.dob ||
                                                        (entityType != 'NONINDIVIDUAL' && !values?.firstName) ||
                                                        (
                                                            (entitySubType === "Minor" ? values?.minorPan === "yes" : true) &&
                                                            (!values?.pan || errors?.pan)
                                                        ) ||
                                                        (errCode === "" &&
                                                            isNormalClient &&
                                                            (!panNumberMatched || !dobChecked)
                                                        ) ||
                                                        !consent ||
                                                        liveLocationCheck.checkPhotoLiveness ||
                                                        liveLocationCheck.checkLocation ||
                                                        (skipUrlBoolean ? false : !panOCR)
                                                        || errors.firstName || errors.gurdianFName
                                                        // ||
                                                        // errCode
                                                    }
                                                    isLoading={isLoading}
                                                    type="submit"
                                                />
                                            </div>
                                        </>
                                    )}
                                {entityType == "NONINDIVIDUAL" &&
                                    <div className="checkStatus">
                                        <button type="button" className="statusLink" onClick={() => {
                                            try {
                                                const screen_name = getScreenName(window.location.pathname);
                                                if (screen_name) {
                                                    mixpanelService({
                                                        event: mixpanelEvents.CTA_CLICKED,
                                                        screen_name,
                                                        text: "Check Account Opening Status",
                                                        cta_type: "sticky",
                                                        cta_class: "secondary",
                                                        cta_service: "AOJ",
                                                    });
                                                }
                                            } catch (e) {
                                                console.error("mixpanel cta_clicked failed", e);
                                            }
                                            checkStatus();
                                        }}>
                                            Check Account Opening Status
                                        </button>
                                    </div>
                                }
                            </fieldset>
                        </form>
                    </div>
                </div>
            }
        </>
    );
};

export default PANInfoMinor;
